const translations = {
  en: {
    nav: {
      findHome: "Find a Home",
      listProperty: "List Your Property",
      dashboard: "Dashboard",
      messages: "Messages",
      login: "Login",
      signUp: "Sign Up",
      findAHome: "Find a Home",
      listAProperty: "List a Property",
      propertyOwner: "Property Owner",
      renter: "Renter",
      signOut: "Sign Out",
      changePassword: "Change Password",
    },
    common: {
      loading: "Loading...",
      back: "Back",
    },
    session: {
      expiredTitle: "Session Ended",
      expiredMsg: "Your session has expired. Please sign in again to continue.",
    },
    supportChat: {
      launcher: "Support",
      title: "Support Chat",
      subtitle: "AI-first help with human escalation",
      welcome: "Hi! I am GharBhada Support AI. Ask me anything, and I can create a support ticket for you if needed.",
      minimize: "Minimize chat",
      placeholder: "Type your issue here...",
      typing: "Thinking...",
      loginRequired: "Please sign in first so I can securely help with your account.",
      unavailable: "Support assistant is temporarily unavailable.",
      createTicket: "Create Support Ticket",
      creatingTicket: "Creating ticket...",
      ticketCreated: "Support ticket created successfully.",
      ticketFailed: "Unable to create a support ticket right now.",
    },
    modal: {
      signOut: "Sign Out",
      signOutConfirm: "Are you sure you want to sign out?",
      cancel: "Cancel",
      changePassword: "Change Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmNewPassword: "Confirm New Password",
      currentPasswordPlaceholder: "Enter current password",
      newPasswordPlaceholder: "At least 8 characters",
      confirmPasswordPlaceholder: "Repeat new password",
      savePassword: "Save Password",
      saving: "Saving…",
      fillAllFields: "Please fill in all fields.",
      passwordsMustMatch: "New passwords do not match.",
      passwordTooShort: "New password must be at least 8 characters.",
      passwordChanged: "Password changed successfully.",
      networkError: "Network error. Please try again.",
    },
    home: {
      hero: {
        badge: "Trusted rentals, built for Nepal",
        title: "Find Verified Rental Homes in Nepal",
        subtitle: "Compare verified homes, message owners quickly, and move with confidence.",
        findBtn: "Find Your Home",
        listBtn: "List Your Property",
        pillVerified: "Verified listings",
        pillNoBroker: "No broker fees",
        pillDirect: "Direct owner contact",
      },
      proof: {
        activeListings: "Active listings",
        cities: "Cities across Nepal",
        avgRent: "Avg. monthly rent",
        brokerFee: "Broker fee — always",
      },
      howItWorks: {
        title: "How It Works",
        subtitle: "From search to signed agreement, everything in one place.",
        step1Title: "Create Account",
        step1Desc: "Sign up as a renter or list your property as an owner — free to join.",
        step2Title: "Search Verified Listings",
        step2Desc: "Browse listings filtered by city, price, bedrooms, and type.",
        step3Title: "Message Owner",
        step3Desc: "Message the owner directly — no middlemen, no added fees.",
        step4Title: "Move In",
        step4Desc: "Visit, agree, sign. GharBhada lets you handle applications digitally.",
      },
      trust: {
        title: "Why Renters Choose GharBhada",
        subtitle: "No broker games. No guesswork. Built for Nepal's real rental market.",
        heading: "Rent with confidence, not guesswork.",
        item1: "Listings reviewed before they go live — no ghost listings",
        item2: "Direct owner chat — no middlemen inflating rent or hiding details",
        item3: "Nepal-based support — we understand the local rental market",
        item4: "Transparent pricing — what you see is what the owner charges",
        contactHeading: "Get in touch",
        location: "Kathmandu Valley, Nepal",
        hours: "Mon–Sat · local team · renters and owners both welcome",
        feature1Title: "Verified Listings",
        feature1Desc: "Every listing is reviewed for quality, photos, and key details",
        feature2Title: "Direct Owner Contact",
        feature2Desc: "Talk directly with owners for faster decisions and fewer surprises",
        feature3Title: "No Broker Fee",
        feature3Desc: "Designed for transparent renter-owner communication whenever possible",
        feature4Title: "Local Support in Nepal",
        feature4Desc: "Need help? Reach us at support@gharbhada.org from anywhere in Nepal",
      },
      testimonials: {
        title: "Early Renters & Owners Have Said",
        subtitle: "Honest feedback from the first users of GharBhada across Nepal",
        role1: "Renter · Kathmandu",
        role2: "Property Owner · Pokhara",
        role3: "Renter · Lalitpur",
      },
      cta: {
        title: "Ready to find your next home in Nepal?",
        subtitle: "Browse real listings from verified property owners — no broker, no hassle.",
        btn: "Browse Properties",
      },
      featured: {
        title: "Featured Verified Rentals",
        subtitle: "Reviewed by our team before going live",
        viewAll: "View all listings",
        viewDetails: "View Details",
        perMonth: "per month",
        bed: "Bed",
        bath: "Bath",
        sqft: "sq ft",
        verified: "Verified",
        unverified: "Unverified",
        loading: "Loading featured listings…",
        noListings: "No featured listings right now.",
      },
    },
    footer: {
      tagline: "Nepal's direct rental platform",
      desc: "Verified listings. Owner contact. No broker required. Built for Nepal's rental market.",
      quickLinks: "Quick Links",
      browse: "Browse Properties",
      list: "List Your Property",
      becomeHost: "Become a Host",
      helpCenter: "Help Center",
      support: "Support",
      contact: "Contact Us",
      safety: "Safety Center",
      community: "Community Guidelines",
      terms: "Terms of Service",
      contactSection: "Contact",
      location: "Kathmandu Valley, Nepal",
      hours: "Mon–Sat · Local rental support",
      welcome: "Renters and owners both welcome",
      copyright: "© 2026 GharBhada. All rights reserved.",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
    },
    findProperty: {
      searchPlaceholder: "Search by location (eg., Kathmandu, Thamel, Lalitpur)",
      all: "All",
      filter: "Filter",
      filters: "Filters",
      priceRange: "Price Range",
      propertyType: "Property Type",
      any: "Any",
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms",
      amenities: "Amenities",
      showMore: "Show more",
      showLess: "Show less",
      clearFilters: "Clear Filters",
      perMonth: "per month",
      bed: "Bed",
      bath: "Bath",
      sqft: "sq ft",
      viewDetails: "View Details",
      loading: "Loading properties…",
      noProperties: "No properties found matching your filters.",
      applyNow: "Apply Now",
      message: "Message",
      ownerPromo: {
        ariaLabel: "Owner listing promotion",
        ctaPrimary: "List Property Free",
        ctaSecondary: "How Free Listing Works",
        inlineCta: "Own a home? List it free",
        empty: {
          eyebrow1: "Trusted Owner Program",
          eyebrow2: "Secure Listings, Zero Brokerage",
          eyebrow3: "Owner First, Tenant Friendly",
          headline1: "No broker fee. No listing charge. Start renting your home for free.",
          headline2: "Upload your property in minutes and rent out directly with zero middleman cost.",
          headline3: "Grow your rental income with free listing and secure owner controls.",
          body1: "GharBhada gives homeowners a direct path to tenants with transparent pricing and secure messaging.",
          body2: "Create your owner account for free and publish listings without paying platform or broker fees.",
          body3: "You keep control of your listing, pricing, and conversations while we handle safe product workflows.",
          point1: "100% free property listing",
          point2: "No broker fee for owners or renters",
          point3: "Free renting workflow from listing to inquiry",
        },
        compact: {
          eyebrow1: "Keep Growing Your Listings",
          eyebrow2: "Trusted Owner Program",
          eyebrow3: "Scale Rentals Without Brokerage",
          headline1: "List more properties with 0 broker fee and 0 listing fee",
          headline2: "Add your next home today and reach tenants faster with direct owner visibility.",
          headline3: "More properties, same promise: zero brokerage and free listing.",
          body1: "Add another property and keep your rental funnel active with secure in-app communication.",
          body2: "Keep expanding with free listings while tenants discover trusted homes across Nepal.",
          body3: "List, manage, and respond in one place while keeping costs low for both sides.",
          point1: "Free listing for every new property",
          point2: "Direct owner-to-tenant communication",
          point3: "No commission on successful renting",
        },
      },
      categories: {
        house: "House",
        apartment: "Apartment",
        villa: "Villa",
        studio: "Studio",
        cottage: "Cottage",
        land: "Land",
        commercial: "Commercial",
        condo: "Condo",
        cabin: "Cabin",
        room: "Room",
        officeSpace: "Office Space",
      },
    },
    login: {
      welcomeBack: "Welcome Back",
      subtitle: "Sign in to your GharBhada account",
      whyTitle: "Why choose GharBhada?",
      feature1Title: "Smart Property Search",
      feature1Desc: "Find Properties with advanced filters and location-based search",
      feature2Title: "Verified Listings",
      feature2Desc: "All properties are verified for authenticity and accuracy",
      feature3Title: "Direct Communication",
      feature3Desc: "Connect directly with property owners and schedule visits",
      feature4Title: "Smart Property Search",
      feature4Desc: "Read reviews and ratings from previous tenants",
      email: "Email",
      password: "Password",
      emailPlaceholder: "Ex. johndoe@xyz.com",
      passwordPlaceholder: "Please enter a password",
      rememberMe: "Remember me",
      forgotPassword: "Forgot password?",
      signingIn: "Signing in…",
      signIn: "Sign in",
      emailRequired: "Email is Required",
      emailInvalid: "Enter a valid Email or Password",
      passwordRequired: "Password is Required",
    },
    signup: {
      welcome: "Welcome to GharBhada",
      subtitle: "Nepal's most trusted rental property platform",
      feature1Title: "Smart Property Search",
      feature1Desc: "Find Properties with advanced filters by location, price, and amenities across Nepal",
      feature2Title: "Save Favorites",
      feature2Desc: "Bookmark properties you love and get notified when similar ones become available",
      feature3Title: "Direct Communication",
      feature3Desc: "Connect directly with property owners without middlemen or extra fees",
      feature4Title: "Verified Listings",
      feature4Desc: "Browse verified properties with authentic photos and accurate information",
      feature5Title: "Schedule Visits",
      feature5Desc: "Book property visits at your convenience with our integrated scheduling system",
      feature6Title: "Market Insights",
      feature6Desc: "Access rental price trends and market analysis for informed decisions",
      firstName: "First Name",
      firstNamePlaceholder: "Ex. John",
      firstNameRequired: "First name is Required",
      lastName: "Last Name",
      lastNamePlaceholder: "Ex. Doe",
      lastNameRequired: "Last name is Required",
      email: "Email",
      emailPlaceholder: "Ex. johndoe@xyz.com",
      emailRequired: "Email is Required",
      emailInvalid: "Enter valid email",
      phone: "Phone Number",
      phonePlaceholder: "Ex. 9841234567",
      phoneRequired: "Phone Number is Required",
      phoneInvalid: "Please enter a valid phone number",
      gender: "Gender",
      genderSelect: "--Please Select--",
      genderMale: "Male",
      genderFemale: "Female",
      genderOther: "Other",
      genderNone: "Prefer Not Say",
      genderRequired: "Please select your gender",
      role: "I am a",
      roleSelect: "--Please Select--",
      roleRenter: "Renter - Looking for property",
      roleOwner: "Property Owner - Listing property",
      roleRequired: "Please select your role",
      createPassword: "Create Password",
      passwordPlaceholder: "Please enter a password",
      passwordRequired: "Password is Required",
      passwordInvalid: "Password must have 1 capital and 1 small letter, 1 number, 1 symbol and atleast 8 characters long",
      confirmPassword: "Confirm Password",
      passwordsMustMatch: "Passwords do not match",
      agreeTerms: "I agree to the Terms of Service and Privacy Policy",
      agreeRequired: "Please accept to the Terms & Conditions to continue.",
      createAccount: "Create Account",
      creating: "Creating account…",
      hasAccount: "Already have an account?",
      loginLink: "Login",
    },
    oauthProfile: {
      title: "Complete Your Profile",
      subtitle: "Finish these required details to complete your Google account setup.",
      stepLabel: "Step 2 of 2",
      formTitle: "Account Details",
      firstName: "First Name",
      firstNamePlaceholder: "Enter first name",
      firstNameRequired: "First name is required.",
      lastName: "Last Name",
      lastNamePlaceholder: "Enter last name",
      lastNameRequired: "Last name is required.",
      phone: "Phone Number",
      phonePlaceholder: "98XXXXXXXX",
      phoneRequired: "Phone number is required.",
      phoneHint: "Enter at least 7 digits.",
      countryCodeRequired: "Country code is required.",
      gender: "Gender",
      genderSelect: "Select gender",
      genderMale: "Male",
      genderFemale: "Female",
      genderOther: "Other",
      genderNone: "Prefer not to say",
      genderRequired: "Please select your gender.",
      role: "Role",
      roleOwner: "Property Owner",
      roleRenter: "Renter",
      roleRequired: "Please select a role.",
      submit: "Complete Account",
      saving: "Saving...",
      tipVerified: "Verified account flow with secure session handoff",
      tipPrivacy: "Your details are used only for trusted rental matching",
      tipEditable: "You can edit these details later from your profile",
      submitFailed: "Could not complete profile. Please try again.",
      networkError: "Network error. Please try again.",
    },
    emailVerificationBanner: {
      title: "Verify Your Email",
      subtitle: "For account security, please verify your email to unlock full trust features.",
      codePlaceholder: "Enter 6-digit code",
      verifyBtn: "Verify",
      verifying: "Verifying...",
      resendBtn: "Resend Code",
      resending: "Sending...",
      resendIn: "Resend in {{seconds}}s",
      invalidCode: "Please enter a valid 6-digit code.",
      verifyFailed: "Unable to verify code.",
      resendFailed: "Unable to resend verification code right now.",
      verified: "Email verified successfully.",
      codeResent: "A new verification code has been sent.",
      requestTimeout: "Request timed out. Please try again.",
      networkError: "Network error. Please try again.",
    },
    pages: {
      helpCenter: "Help Center",
        communityGuidelines: "Community Guidelines",
        safetyCenter: "Safety Center",
        contactUs: "Contact Us",
        privacyPolicy: "Privacy Policy",
        termsOfService: "Terms of Service",
        cookiePolicy: "Cookie Policy",
        back: "← Back",
        contactSupport: "Email support@gharbhada.org",
        stillNeedHelp: "Still need help?",
        stillNeedHelpDesc: "Our Nepal-based support team is available Mon–Sat and happy to assist renters and owners alike.",
        reportIssue: "Report an issue right now",
        reportIssueDesc: "Our team takes safety reports seriously and responds fast.",
        reportBtn: "Report to support@gharbhada.org",
        contactQuestion: "Questions about these guidelines?",
        contactQuestionDesc: "Our team is happy to clarify any of the above.",
        contactCta: "Contact Us",
      },
      renterDashboard: {
        welcomeSubtitle: "Welcome back! Here's what's happening with your rented properties.",
        noActiveRental: "No Active Rental",
        noActiveRentalDesc: "You don't have any property rented yet. Start exploring available properties and find your perfect home.",
        browseBtn: "Browse Available Rentals",
        myApplications: "My Applications",
        noApplications: "You have not submitted any rental applications yet.",
        latestUpdates: "Latest updates from owners",
        ownerLabel: "Owner:",
        dashboardTitle: "Dashboard",
        welcomeBackName: "Welcome back,",
        notifications: "Notifications",
        noNotifications: "No new updates.",
        activeLease: "Active Lease",
        beds: "Beds",
        bath: "Bath",
        sqft: "sqft",
        monthlyRent: "Monthly Rent",
        payRent: "Pay Rent",
        nextPaymentDue: "Next Payment Due",
        dueIn: "Due in",
        days: "days",
        leaseEnds: "Lease Ends",
        monthsRemaining: "months remaining",
        landlord: "Landlord",
        ownerRequestedTermination: "Owner Requested Lease Termination",
        reason: "Reason:",
        approveTermination: "Approve Termination",
        maintenance: "Maintenance",
        lease: "Lease",
        endLease: "End Lease",
        cancelRequest: "Cancel Request",
        ownerRequested: "Owner Requested",
        contact: "Contact",
        writeReview: "Write Review",
        requestTerminationTitle: "Request Lease Termination",
        terminationNote: "Your landlord must approve this request. Once approved, the lease will end immediately.",
        terminationReasonLabel: "Reason for Termination",
        terminationPlaceholder: "Please explain why you want to end the lease early...",
        terminationHint: "Be specific and respectful in your explanation.",
        cancel: "Cancel",
        submitting: "Submitting...",
        submitRequest: "Submit Request",
        writeReviewTitle: "Write a Review",
        propertyLabel: "Property",
        statusApproved: "Approved",
        statusRejected: "Rejected",
        statusUnderReview: "Under Review",
        noteApproved: "Your application has been approved!",
        noteRejected: "Your application was not accepted.",
        noteUnderReview: "Waiting for owner decision.",
      },
      ownerDashboard: {
        welcomeSubtitle: "Welcome back! Here's what's happening with your properties.",
        addProperty: "Add Property",
        totalProperties: "Total Properties",
        activeRentals: "Active Rentals",
        activeApartments: "Active Apartments",
        activeApartmentsDesc: "Currently rented (subset of total properties)",
        pendingInquiries: "Pending Inquiries",
        estRevenue: "Estimated Monthly Revenue",
        propertiesTab: "Properties",
        applicationsTab: "Applications",
        appFormBtn: "Application Form",
        colNum: "#",
        colProperties: "Properties",
        colStatus: "Status",
        colRenter: "Renter",
        colPrice: "Price",
        colSettings: "Settings",
        noProperties: "No properties found. Please add a property to see it listed here.",
        statusRented: "Rented",
        statusActive: "Active",
        statusUnlisted: "Unlisted",
        statusAvailable: "Available",
        renterRequestedTermination: "Renter Requested Termination",
        terminationPending: "Termination Pending",
        notRented: "Not rented",
        viewDetails: "View Details",
        endLease: "End Lease",
        noApplications: "No rental applications yet.",
        colProperty: "Property",
        colApplicant: "Applicant",
        colSubmitted: "Submitted",
        colAction: "Action",
        view: "View",
        applicant: "Applicant",
        name: "Name",
        email: "Email",
        phone: "Phone",
        appAnswers: "Application Answers",
        submittedDocs: "Submitted Documents",
        rejectionReasonLabel: "Rejection Reason:",
        reasonForRejection: "Reason for Rejection",
        reject: "Reject",
        approveCreateRental: "Approve & Create Rental",
        confirmRejection: "Confirm Rejection",
        close: "Close",
        cancel: "Cancel",
        property: "Property",
        currentTenant: "Current Tenant",
        renterLabel: "Renter",
        reasonForTermination: "Reason for Termination",
        noReasonProvided: "No reason provided",
        denyRequest: "Deny Request",
        approveTermination: "Approve Termination",
        cancelRequest: "Cancel Request",
        denyTerminationTitle: "Deny Termination Request",
        reasonForDenial: "Reason for Denial",
        denyNote: "You are about to deny the renter's termination request. Please provide a clear reason. The lease will continue as normal.",
        denialPlaceholder: "Explain why you are denying this termination request...",
        denyingHint: "This reason will be communicated to the renter",
        denying: "Denying...",
        renterRequestedModal: "Renter Requested Lease Termination",
        ownerRequestedModal: "Lease Termination Request",
        terminationNoteRenter: "The renter has requested to terminate this lease. Review the reason above and approve if you agree.",
        terminationNoteOwner: "You have requested to terminate this lease. The renter can approve or you can cancel this request.",
        loading: "Loading...",
        previewNotSupported: "Preview not supported for this file type.",
        docPreviewTitle: "Document Preview",
        kycRequired: "Identity Verification Required",
        kycRequiredMsg: "Please complete KYC verification to list properties and receive rent payments.",
        kycPending: "KYC Under Review",
        kycPendingMsg: "Your documents are being reviewed. This usually takes 7–14 days.",
        kycRejected: "KYC Rejected",
        kycRejectedMsg: "Your KYC was rejected. Please resubmit with correct documents.",
        kycResubmit: "Resubmission Required",
        kycResubmitMsg: "Please update and resubmit your KYC documents.",
        kycVerifyNow: "Verify Now",
        kycResubmitBtn: "Resubmit",
        // Section titles
        dashboard: "Dashboard",
        overviewSection: "Overview",
        activeRentalsSection: "Active Rentals",
        appFormSection: "Application Form",
        accountSettings: "Account Settings",
        // Sidebar
        mainNavLabel: "Main",
        configNavLabel: "Configuration",
        propertyOwnerRole: "Property Owner",
        // Topbar chips
        kycPendingChip: "KYC Pending",
        verifyIdentityChip: "Verify Identity",
        verifiedChip: "Verified",
        // Greeting
        greetingPrefix: "Welcome back",
        greetingSnapshot: "Here's a snapshot of your properties and activity.",
        // Metric sub-labels
        listedLabel: "listed",
        unlistedLabel: "unlisted",
        currentlyOccupied: "Currently occupied",
        noMonthlyData: "No monthly data yet",
        // Quick actions
        manageProperties: "Manage Properties",
        reviewApplications: "Review Applications",
        addNewProperty: "Add New Property",
        pendingBadge: "pending",
        // Recent apps card
        recentApplications: "Recent Applications",
        viewAll: "View all \u2192",
        // Properties section
        noPropertiesYet: "No properties yet",
        noPropertiesMsg: "List your first property to start receiving applications.",
        listAProperty: "List a Property",
        perMonth: "/mo",
        terminationPendingTitle: "Termination pending",
        editPropertyTitle: "Edit property",
        propertySingular: "property",
        propertyPlural: "properties",
        // Filter tabs
        filterAll: "All",
        filterPending: "Pending",
        filterApproved: "Approved",
        filterRejected: "Rejected",
        noAppsFromRenters: "Applications from renters will appear here.",
        noAppsFiltered: "No applications at the moment for this filter.",
        // Active Rentals section
        noActiveRentals: "No active rentals",
        noActiveRentalsMsg: "When a property is rented it will appear here.",
        statusRentedPill: "Rented",
        tenantLabel: "Tenant",
        monthlyRentLabel: "Monthly Rent",
        leaseStartLabel: "Lease Start",
        leaseEndLabel: "Lease End",
        // Application Form section
        appFormQuestions: "Application Form Questions",
        appFormStandardNote: "The standard sections (Personal Info, Employment, Rental Details, References, Documents) are always included. Add extra questions below that renters must answer when applying to your properties.",
        noCustomQuestions: "No custom questions yet. Add one below.",
        addAQuestion: "Add a Question",
        questionLabelField: "Question / Label",
        typeLabel: "Type",
        shortText: "Short Text",
        longText: "Long Text",
        numberType: "Number",
        yesNo: "Yes / No",
        fileUpload: "File Upload",
        requiredLabel: "Required",
        addQuestion: "Add Question",
        saveTemplate: "Save Template",
        savingLabel: "Saving...",
        // Account Settings section
        profileSection: "Profile",
        fullNameLabel: "Full Name",
        accountRoleLabel: "Account Role",
        editProfile: "Edit Profile",
        identityVerificationTitle: "Identity Verification (KYC)",
        identityVerifiedStatus: "Identity Verified",
        underReviewStatus: "Under Review",
        verificationRejectedStatus: "Verification Rejected",
        notSubmittedStatus: "Not Submitted",
        kycVerifiedDesc: "Your identity has been verified. You have full access to all owner features.",
        kycUnderReviewDesc: "Your documents are being reviewed. This usually takes 7–14 days.",
        kycRejectedDesc: "Your submission was rejected. Please resubmit with correct documents.",
        kycNotSubmittedDesc: "Submit your identity documents to unlock property listing and other features.",
        checkStatus: "Check Status",
        resubmitKyc: "Resubmit KYC",
        startKyc: "Start KYC",
        securitySection: "Security",
        passwordLabel: "Password",
        changePassword: "Change Password",
        dangerZone: "Danger Zone",
        signOutMsg: "Signing out will clear your local session data.",
        signOut: "Sign Out",
        // Mobile bottom nav
        overviewTab: "Overview",
        appsTab: "Apps",
        moreTab: "More",
        // Modals
        appModalTitlePrefix: "Application",
        previewLoadingLabel: "Loading...",
        previewBtn: "Preview",
        rejectPlaceholder: "Explain why you are rejecting this application...",
        appliedLabel: "Applied",
        untilLabel: "Until",
      },
    kyc: {
      title: "Identity Verification (KYC)",
      subtitle: "Verify your identity to unlock full access.",
      stepPersonal: "Personal Info",
      stepIdentity: "Identity Document",
      stepUpload: "Upload Documents",
      stepReview: "Review & Submit",
      forRole: "Verify your identity to unlock full access and build trust with {{role}}.",
      roleRenterPlural: "owners",
      roleOwnerPlural: "renters",
      fullName: "Full Name",
      dateOfBirth: "Date of Birth",
      nationality: "Nationality",
      permanentAddress: "Permanent Address",
      currentAddress: "Current Address",
      currentAddressIfDifferent: "Current Address (if different from above)",
      documentType: "Document Type",
      documentNumber: "Document Number",
      citizenship: "Citizenship Card",
      passport: "Passport",
      drivingLicense: "Driving Licence",
      voterId: "Voter ID",
      ownerDetails: "Owner Details",
      optionalRecommended: "(optional but recommended)",
      panNumber: "PAN Number",
      bankName: "Bank Name",
      bankAccount: "Bank Account Number",
      docFront: "Front Side of Document",
      docBack: "Back Side of Document",
      selfie: "Selfie / Live Photo",
      uploadTitle: "Upload Documents",
      reviewTitle: "Review & Submit",
      submitConfirm: "By submitting, you confirm that all information and documents are genuine and belong to you. Providing false documents is a violation of our Terms of Service and may be reported to relevant authorities.",
      acceptedFormats: "Accepted formats: JPEG, PNG, WEBP, PDF. Max 10 MB per file. Documents must be clear and fully visible.",
      clickToUpload: "Click to upload",
      dragDrop: "or drag & drop",
      uploaded: "Uploaded",
      continue: "Continue",
      back: "Back",
      cancel: "Cancel",
      required: "Required",
      fullNameRequired: "Full name is required.",
      dateOfBirthRequired: "Date of birth is required.",
      permanentAddressRequired: "Permanent address is required.",
      documentNumberRequired: "Document number is required.",
      documentFrontRequired: "Front side of document is required.",
      selfieRequired: "Selfie is required.",
      asOnId: "As it appears on your ID",
      addressPlaceholder: "Ward No., Municipality / VDC, District, Province",
      currentAddressPlaceholder: "Optional — only if different from permanent address",
      documentNumberPlaceholder: "e.g. 12-01-76-12345",
      panPlaceholder: "e.g. 123456789",
      bankNamePlaceholder: "e.g. Nepal Bank Limited",
      bankAccountPlaceholder: "Your bank account number",
      uploadFrontHint: "Upload the front side of your {{document}}",
      uploadBackHint: "Optional — include if applicable",
      uploadSelfieHint: "Hold your ID next to your face. Clear, well-lit photo.",
      reviewFullName: "Full Name",
      reviewDob: "Date of Birth",
      reviewNationality: "Nationality",
      reviewPermanentAddress: "Permanent Address",
      reviewCurrentAddress: "Current Address",
      reviewDocType: "Document Type",
      reviewDocNumber: "Document Number",
      reviewPan: "PAN Number",
      reviewBank: "Bank Name",
      reviewAccount: "Account No.",
      reviewDocFront: "Document Front",
      reviewDocBack: "Document Back",
      reviewSelfie: "Selfie",
      dash: "—",
      loading: "Loading your KYC status…",
      submit: "Submit KYC",
      submitting: "Submitting…",
      successTitle: "KYC Submitted — Under Review",
      successMsg: "Your identity documents have been submitted. Our team will review them within 7–14 days.",
      pendingMsg: "Your identity documents have been submitted. Our team will review them within 7–14 days. You'll be able to use the platform fully once verified.",
      approvedTitle: "Identity Verified",
      approvedMsg: "Your KYC verification is complete. You have full access to all GharBhada features.",
      rejectedTitle: "KYC Rejected",
      resubmitTitle: "Resubmission Required",
      rejectedFallback: "Your submission did not meet the requirements.",
      resubmitHelp: "Please correct the issues and resubmit below.",
      submitFailed: "Submission failed. Please try again.",
      networkError: "Network error. Please check your connection and try again.",
      goToDashboard: "Go to Dashboard",
      modal: {
        ownerBadge: "Property Owner",
        renterBadge: "Renter",
        ownerHeadline: "Unlock Your Full Owner Potential",
        renterHeadline: "Get Ahead of Every Other Applicant",
        ownerSubtext: "Verified owners earn more trust, get 3x more inquiries, and can receive digital rent payments — all with one quick verification.",
        renterSubtext: "Verified renters get approved twice as fast and are preferred by owners. Take 5 minutes now — be the applicant owners say yes to.",
        actionRequiredTitle: "Action Required: Resubmit Your KYC",
        actionRequiredOwnerSubtext: "Your previous submission was not accepted. Update your documents and resubmit to restore full access to your owner features.",
        actionRequiredRenterSubtext: "Your previous submission was not accepted. Please resubmit with clear, valid documents to apply for rentals again.",
        pendingStripTitle: "KYC Under Review",
        pendingStripMsg: "Your identity documents are being reviewed. We'll notify you once verified (usually 7–14 days). You'll gain full access immediately after approval.",
        rejectStripResubmitTitle: "KYC Resubmission Required",
        rejectStripRejectedTitle: "KYC Rejected",
        rejectStripMsg: "You must fix and resubmit your documents to use GharBhada fully.",
        resubmitNow: "Resubmit Now",
        verifyNow: "Verify My Identity Now",
        fixAndResubmit: "Fix & Resubmit Documents",
        laterOwner: "I'll verify later (not recommended — you're missing inquiries)",
        laterRenter: "Remind me later (I don't mind slower approvals)",
        ownerBenefits: [
          "Verified badge on every listing — renters instantly notice and prefer you",
          "Higher search ranking — verified listings appear above unverified ones",
          "3x more rental inquiries — renters trust verified owners more",
          "Receive rent payments digitally through GharBhada — requires KYC",
          "Legal protection in disputes — your identity is on official record",
          "One-time process — verified permanently, no annual renewal"
        ],
        renterBenefits: [
          "KYC badge on your profile — stand out from hundreds of applications",
          "2x faster approvals — owners shortlist verified renters first",
          "Apply to premium listings — some verified properties require KYC renters",
          "Builds trust before you even message — owners respond faster to verified renters",
          "Identity protected in disputes — KYC works both ways",
          "One-time process — verified forever on GharBhada"
        ],
        ownerProof1: "More Inquiries",
        ownerProof2: "Owner Approval",
        ownerProof3: "Days to Review",
        renterProof1: "Faster Approval",
        renterProof2: "Owner Preference",
        renterProof3: "To Complete"
      }
    },
    amenities: {
      sectionTitle: "Amenities",
      sectionDesc: "What does your property offer?",
      wifi: "WiFi",
      kitchen: "Kitchen",
      water: "Water",
      freeparking: "Free Parking",
      airconditioning: "Air Conditioning",
      heating: "Heating",
      electricity: "Electricity",
      petfriendly: "Pet Friendly",
      gym: "Gym",
      hotwater: "Hot Water",
      playground: "Playground",
      disablefriendly: "Disable Friendly",
    },
    profile: {
      serverError: "Cannot reach the server. Make sure the backend is running on port 7000.",
      retry: "Retry",
      tabPersonal: "Personal Info",
      tabAccount: "Account Settings",
      tabKyc: "Identity (KYC)",
      roleOwner: "Property Owner",
      roleRenter: "Renter",
      kycNotSubmitted: "Not Submitted",
      kycPending: "Under Review",
      kycApproved: "Verified",
      kycRejected: "Rejected",
      kycResubmit: "Resubmission Required",
      personalTitle: "Personal Information",
      firstName: "First Name",
      firstNamePlaceholder: "Enter first name",
      lastName: "Last Name",
      lastNamePlaceholder: "Enter last name",
      email: "Email Address",
      gender: "Gender",
      genderSelect: "— Select —",
      genderMale: "Male",
      genderFemale: "Female",
      genderOther: "Other",
      genderPreferNot: "Prefer not to say",
      countryCode: "Country Code",
      countryCodePlaceholder: "977",
      phone: "Phone Number",
      phonePlaceholder: "98XXXXXXXX",
      calendarPreference: "Calendar Preference",
      calendarBS: "Bikram Sambat (BS) — Nepali Calendar",
      calendarAD: "Anno Domini (AD) — Gregorian Calendar",
      calendarHint: "Used for rent due dates, payment reminders, and date displays.",
      saveChanges: "Save Changes",
      saving: "Saving…",
      saveSuccess: "Profile updated successfully.",
      saveErrorRequired: "First name and last name are required.",
      saveErrorFailed: "Failed to update profile.",
      networkError: "Network error. Please try again.",
      changePasswordTitle: "Change Password",
      currentPassword: "Current Password",
      currentPasswordPlaceholder: "Enter current password",
      newPassword: "New Password",
      newPasswordPlaceholder: "At least 8 characters",
      confirmPassword: "Confirm New Password",
      confirmPasswordPlaceholder: "Repeat new password",
      updatePassword: "Update Password",
      pwSuccess: "Password changed successfully.",
      pwErrorRequired: "All fields are required.",
      pwErrorMismatch: "New passwords do not match.",
      pwErrorTooShort: "New password must be at least 8 characters.",
      pwErrorFailed: "Failed to change password.",
      accountDetailsTitle: "Account Details",
      accountType: "Account Type",
      dangerZoneTitle: "Danger Zone",
      dangerZoneText: "Deleting your account is permanent. All your data — listings, applications, messages, and KYC records — will be removed. This action cannot be undone.",
      deleteAccount: "Delete My Account",
      deleteConfirm: "Are you absolutely sure? This cannot be undone.",
      deleteContactSupport: "Yes, contact support to delete",
      cancel: "Cancel",
      kycTitle: "Identity Verification (KYC)",
      kycStatus: "Status",
      kycVerifiedOn: "Verified On",
      kycAccountRole: "Account Role",
      kycUnlockedLabel: "What you unlocked",
      kycGetVerifiedLabel: "What you get when verified",
      kycOwnerBenefits: [
        "Verified badge on every listing",
        "Higher search ranking over unverified listings",
        "3× more rental inquiries from renters",
        "Ability to receive digital rent payments",
        "Legal identity protection in disputes"
      ],
      kycRenterBenefits: [
        "KYC badge on your renter profile",
        "2× faster approval from property owners",
        "Access to premium verified property listings",
        "Owners respond faster to verified renters",
        "Identity protection in rental disputes"
      ],
      kycCtaPending: "View Submission Status",
      kycCtaResubmit: "Fix & Resubmit Documents",
      kycCtaStart: "Start Verification — 5 min",
    },
    propertySettings: {
      manageDetails: "Manage all your property details",
      basicInfo: "Basic Info",
      basicInfoDesc: "Essential details about your property",
      location: "Location",
      locationDesc: "Pick your property location on the map",
      pricing: "Pricing",
      pricingDesc: "Set rental rates and stay policies",
      amenities: "Amenities",
      amenitiesDesc: "Select all amenities available at your property",
      images: "Images",
      imagesDesc: "Upload and manage property photos",
      policies: "Policies",
      policiesDesc: "Set house rules and guest policies",
      propertyName: "Property Name",
      description: "Description",
      propertyType: "Property Type",
      status: "Status",
      statusActive: "Active",
      statusInactive: "Inactive",
      statusMaintenance: "Maintenance",
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms",
      area: "Area (sq. ft)",
      furnishing: "Furnishing",
      monthlyRent: "Monthly Rent (NPR)",
      minimumStay: "Minimum Stay (months)",
      checkInTime: "Check-in Time",
      checkOutTime: "Check-out Time",
      cancellationPolicy: "Cancellation Policy",
      policyStrict: "Strict (Full refund 7 days before)",
      policyModerate: "Moderate (50% refund 3 days before)",
      policyFlexible: "Flexible (Full refund anytime)",
      pickFromMap: "Pick Location from Map",
      selectLocation: "Select Location",
      selectedLocation: "Selected Location",
      mapPreview: "Map Preview",
      mapPreviewHint: "This preview updates after you pick/drag a location on the map.",
      state: "State/Province",
      district: "District",
      municipality: "Municipality",
      address: "Full Address",
      dragOrClick: "Drag images here or click to upload",
      supportedFormats: "Supports: JPG, PNG, WebP",
      newImages: "New Images to Upload",
      existingImages: "Existing Images",
      markedForDelete: "Marked for Deletion",
      houseRules: "House Rules",
      petsAllowed: "Pets Allowed",
      smokingAllowed: "Smoking Allowed",
      visitorsPolicy: "Visitors Policy",
      visitorsAllowed: "Visitors Allowed",
      visitorsRestricted: "Visitors Restricted",
      visitorsNotAllowed: "Visitors Not Allowed",
      verification: "Verification",
      verificationTitle: "Property Verification",
      verificationDesc: "Boost renter trust with verified badge",
      verificationStatusApproved: "Verified",
      verificationStatusPending: "Verification Pending",
      verificationStatusRejected: "Verification Rejected",
      verificationStatusUnverified: "Not Verified",
      verificationApprovedDesc: "Your property has been verified. You have the verified badge displayed on your listings.",
      verificationPendingDesc: "Your verification request is being reviewed. This usually takes 1-2 business days.",
      verificationRejectedDesc: "Your verification was rejected. You can resubmit documents.",
      verificationUnverifiedDesc: "Submit proof documents to get your property verified.",
      verificationBenefitsTitle: "Benefits of Verification",
      verificationBenefit1: "✓ Build trust with renters",
      verificationBenefit2: "✓ Increase property visibility",
      verificationBenefit3: "✓ Get verified badge on listings",
      verificationBenefit4: "✓ Reduce fraudulent inquiries",
      verificationBenefit5: "✓ Higher chance of property rental",
      verificationCtaPending: "Check Verification Status",
      verificationCtaSubmit: "Submit Verification Documents",
      verificationSubmitting: "Submitting...",
      verificationApprovedInfo: "Your property is verified and will display the badge on all your listings.",
      verificationOwnershipDoc: "Ownership Certificate",
      verificationTaxDoc: "Tax/Ward Clearance Certificate",
      verificationLandDoc: "Land Deed (Optional)",
      verificationUtilityDoc: "Utility Bill (Optional)",
      verificationNotes: "Supporting Notes (Optional)",
      verificationNotesPlaceholder: "Add context for admin review",
      verificationRequiredDocsError: "Please upload ownership certificate and tax/ward clearance documents.",
      verificationSubmitted: "Verification request submitted successfully.",
      verificationStatusUpdated: "Verification status updated.",
    },
    propertyDashboard: {
      loading: "Loading property dashboard...",
      loadFailed: "Could not load property dashboard.",
      failedLoadPropertyData: "Failed to load property data.",
      networkErrorTryAgain: "Network error. Please try again.",
      failedLoadUtilityData: "Failed to load utility data.",
      backOwnerDashboard: "Back to Owner Dashboard",
      ownerDashboard: "Owner Dashboard",
      propertyDashboardTitle: "Property Dashboard",
      locationNotSet: "Location not set",
      rented: "Rented",
      vacant: "Vacant",
      verified: "Verified",
      verificationPending: "Verification Pending",
      rejected: "Rejected",
      notVerified: "Not Verified",
      tabOverview: "Overview",
      tabUtilities: "Utilities",
      tabSettings: "Property Settings",
      monthlyRent: "Monthly Rent",
      utilitiesBilledTracked: "Utilities Billed (Tracked)",
      leaseProgress: "Lease Progress",
      daysRemaining: "Days Remaining",
      pendingApplications: "Pending Applications",
      leaseTimeline: "Lease Timeline",
      to: "to",
      noActiveLease: "No active lease",
      elapsed: "Elapsed",
      total: "Total",
      daysShort: "day(s)",
      activeTenancyAndPaymentContext: "Active Tenancy and Payment Context",
      terminationRequested: "Termination Requested",
      terminationInProgress: "Termination in progress",
      requestedBy: "Requested by",
      you: "You",
      cancelRequest: "Cancel Request",
      tenantInformation: "Tenant Information",
      fullName: "Full Name",
      email: "Email",
      phone: "Phone",
      leaseDetails: "Lease Details",
      startDate: "Start Date",
      endDate: "End Date",
      status: "Status",
      unknown: "unknown",
      paymentSummary: "Payment Summary",
      utilityTracked: "Utility Tracked",
      calendar: "Calendar",
      bikramSambat: "Bikram Sambat",
      change: "Change",
      propertyIsVacant: "Property is Vacant",
      noActiveTenancyDesc: "No active tenancy. You can still configure utility rates and meter baseline in the Utilities tab.",
      configureUtilities: "Configure Utilities",
      propertySnapshot: "Property Snapshot",
      bed: "Bed",
      bath: "Bath",
      sqft: "sq.ft",
      locationPending: "Location pending",
      utilityBillingTitle: "Utility Billing and Meter Intelligence",
      utilityBillingDesc: "Track electricity/water meter units, update tariffs, estimate bills, and keep a clean reading history.",
      loadingUtilityData: "Loading utility data...",
      utilityProfileSetup: "Utility Profile Setup",
      utilityProfileSetupDesc: "Define meter numbers, baseline units at lease start, and per-unit rates.",
      electricityMeterNo: "Electricity Meter No",
      waterMeterNo: "Water Meter No",
      electricityMeterNoPlaceholder: "e.g., NEA-12234",
      waterMeterNoPlaceholder: "e.g., KUKL-7788",
      electricityRatePerUnit: "Electricity Rate per Unit (NPR)",
      waterRatePerUnit: "Water Rate per Unit (NPR)",
      electricityRate: "Electricity Rate",
      waterRate: "Water Rate",
      electricityStartUnit: "Electricity Start Unit",
      waterStartUnit: "Water Start Unit",
      meterStartDate: "Meter Start Date",
      notes: "Notes",
      optionalBillingRemarks: "Optional billing remarks",
      saving: "Saving...",
      saveUtilityProfile: "Save Utility Profile",
      couldNotSaveUtilityProfile: "Could not save utility profile.",
      utilityProfileSaved: "Utility profile saved.",
      networkErrorSavingUtilityProfile: "Network error while saving utility profile.",
      priceEstimator: "Price Estimator",
      priceEstimatorDesc: "Instant estimate from rates x unit consumption.",
      electricityUnitsKwh: "Electricity Units (kWh)",
      waterUnitsOnly: "Water Units",
      totalEstimate: "Total Estimate",
      latestRecordedMeters: "Latest Recorded Meters",
      units: "units",
      on: "on",
      noReadingYet: "No reading yet",
      add: "Add",
      meterReading: "Meter Reading",
      readingDate: "Reading Date",
      meterUnit: "Meter Unit",
      currentMeterUnit: "Current meter unit",
      optionalNote: "Optional note",
      couldNotAdd: "Could not add",
      reading: "reading",
      meterReadingAdded: "Meter reading added.",
      networkErrorAddingReading: "Network error while adding reading.",
      utilityReadingHistory: "Utility Reading History",
      date: "Date",
      consumed: "Consumed",
      rate: "Rate",
      amount: "Amount",
      noReadingsYet: "No readings yet.",
      thisMonthUtilities: "This Month Utilities",
      monthlyUtilityRecords: "Monthly Utility Records",
      month: "Month",
      electricityUnits: "Electricity Units",
      electricityAmount: "Electricity Amount",
      waterUnits: "Water Units",
      waterAmount: "Water Amount",
      totalAmount: "Total Amount",
      noMonthlyRecords: "No monthly records yet.",
      confirmTitle: "Please Confirm",
      confirmCriticalUpdateTitle: "Confirm Critical Utility Update",
      confirmCriticalUpdateMsg: "You are about to update critical utility numbers.",
      confirmReadingTitle: "Confirm Meter Reading",
      utility: "Utility",
      electricity: "Electricity",
      water: "Water",
      previousUnit: "Previous unit",
      newUnit: "New unit",
      consumedUnits: "Consumed units",
      estimatedAmount: "Estimated amount",
      updateNow: "Update Now",
      saveReading: "Save Reading",
      proceed: "Proceed",
      cancel: "Cancel",
      close: "Close",
      readingRequired: "Reading date and meter unit are required.",
      requestLeaseTermination: "Request Lease Termination",
      pleaseProvideReason: "Please provide a reason.",
      failedToSubmitRequest: "Failed to submit request.",
      terminationRequestSent: "Termination request sent to the renter.",
      terminationModalMsgPrefix: "This sends a termination request to",
      terminationModalMsgSuffix: "The lease ends only after approval.",
      terminationReasonPlaceholder: "Provide reason for lease termination",
      tenant: "tenant",
      reason: "Reason",
      sendRequest: "Send Request",
      sending: "Sending...",
    },
  },

  ne: {
    nav: {
      findHome: "घर खोज्नुहोस्",
      listProperty: "सम्पत्ति सूचीबद्ध गर्नुहोस्",
      dashboard: "ड्यासबोर्ड",
      messages: "सन्देशहरू",
      login: "लगइन",
      signUp: "दर्ता गर्नुहोस्",
      findAHome: "घर खोज्नुहोस्",
      listAProperty: "सम्पत्ति सूचीबद्ध गर्नुहोस्",
      propertyOwner: "सम्पत्ति मालिक",
      renter: "भाडावाल",
      signOut: "बाहिर निस्कनुहोस्",
      changePassword: "पासवर्ड बदल्नुहोस्",
    },
    common: {
      loading: "लोड हुँदैछ...",
      back: "फिर्ता",
    },
    session: {
      expiredTitle: "सत्र समाप्त भयो",
      expiredMsg: "तपाईंको सत्र समाप्त भयो। जारी राख्न कृपया फेरि साइन इन गर्नुहोस्।",
    },
    supportChat: {
      launcher: "सहयोग",
      title: "सहयोग च्याट",
      subtitle: "AI सहयोग र आवश्यक पर्दा मानव समर्थन",
      welcome: "नमस्ते! म GharBhada सपोर्ट AI हुँ। तपाईं प्रश्न सोध्न सक्नुहुन्छ, र आवश्यक परे म तपाईंको सपोर्ट टिकट पनि बनाइदिन सक्छु।",
      minimize: "च्याट सानो बनाउनुहोस्",
      placeholder: "आफ्नो समस्या यहाँ लेख्नुहोस्...",
      typing: "जवाफ तयार गर्दै...",
      loginRequired: "खातासम्बन्धी सुरक्षित सहयोगका लागि कृपया पहिले लगइन गर्नुहोस्।",
      unavailable: "अहिले सपोर्ट सहायक उपलब्ध छैन।",
      createTicket: "सपोर्ट टिकट बनाउनुहोस्",
      creatingTicket: "टिकट बनाउँदै...",
      ticketCreated: "सपोर्ट टिकट सफलतापूर्वक बनेको छ।",
      ticketFailed: "अहिले सपोर्ट टिकट बनाउन सकेनौं।",
    },
    modal: {
      signOut: "बाहिर निस्कनुहोस्",
      signOutConfirm: "के तपाईं साँच्चै बाहिर निस्कन चाहनुहुन्छ?",
      cancel: "रद्द गर्नुहोस्",
      changePassword: "पासवर्ड बदल्नुहोस्",
      currentPassword: "हालको पासवर्ड",
      newPassword: "नयाँ पासवर्ड",
      confirmNewPassword: "नयाँ पासवर्ड पुष्टि गर्नुहोस्",
      currentPasswordPlaceholder: "हालको पासवर्ड लेख्नुहोस्",
      newPasswordPlaceholder: "कम्तीमा ८ अक्षर",
      confirmPasswordPlaceholder: "नयाँ पासवर्ड दोहोर्याउनुहोस्",
      savePassword: "पासवर्ड सुरक्षित गर्नुहोस्",
      saving: "सुरक्षित गर्दै…",
      fillAllFields: "कृपया सबै फिल्डहरू भर्नुहोस्।",
      passwordsMustMatch: "नयाँ पासवर्डहरू मेल खाएनन्।",
      passwordTooShort: "नयाँ पासवर्ड कम्तीमा ८ अक्षर हुनुपर्छ।",
      passwordChanged: "पासवर्ड सफलतापूर्वक बदलियो।",
      networkError: "नेटवर्क त्रुटि। कृपया पुनः प्रयास गर्नुहोस्।",
    },
    home: {
      hero: {
        badge: "विश्वसनीय भाडा, नेपालका लागि बनाइएको",
        title: "नेपालमा प्रमाणित भाडाका घरहरू खोज्नुहोस्",
        subtitle: "प्रमाणित घरहरू तुलना गर्नुहोस्, मालिकलाई सिधै सन्देश पठाउनुहोस्, र विश्वासका साथ सर्नुहोस्।",
        findBtn: "आफ्नो घर खोज्नुहोस्",
        listBtn: "सम्पत्ति सूचीबद्ध गर्नुहोस्",
        pillVerified: "प्रमाणित सूचीहरू",
        pillNoBroker: "दलाल शुल्क छैन",
        pillDirect: "मालिकसँग सिधा सम्पर्क",
      },
      proof: {
        activeListings: "सक्रिय सूचीहरू",
        cities: "नेपालका शहरहरू",
        avgRent: "औसत मासिक भाडा",
        brokerFee: "दलाल शुल्क — सधैं",
      },
      howItWorks: {
        title: "कसरी काम गर्छ",
        subtitle: "खोजीदेखि सम्झौतासम्म, सबै एकै ठाउँमा।",
        step1Title: "खाता बनाउनुहोस्",
        step1Desc: "भाडावाल वा मालिकको रूपमा दर्ता गर्नुहोस् — निःशुल्क।",
        step2Title: "प्रमाणित सूचीहरू खोज्नुहोस्",
        step2Desc: "शहर, मूल्य, शयनकोठा, र प्रकारले फिल्टर गरेर सूचीहरू हेर्नुहोस्।",
        step3Title: "मालिकलाई सन्देश पठाउनुहोस्",
        step3Desc: "मालिकलाई सिधै सन्देश पठाउनुहोस् — कुनै बिचौलिया छैन।",
        step4Title: "घरमा सर्नुहोस्",
        step4Desc: "भ्रमण गर्नुहोस्, सहमत हुनुहोस्, हस्ताक्षर गर्नुहोस्। डिजिटल आवेदन।",
      },
      trust: {
        title: "भाडावालहरूले घरभाडा किन छान्छन्",
        subtitle: "दलाल खेलहरू छैन। अनुमान छैन। नेपालको वास्तविक भाडा बजारका लागि बनाइएको।",
        heading: "अनुमानको भरमा होइन, विश्वासका साथ भाडामा लिनुहोस्।",
        item1: "सूचीहरू लाइभ हुनुअघि समीक्षा — कुनै नक्कली सूची छैन",
        item2: "मालिकसँग सिधा कुराकानी — भाडा बढाउने बिचौलिया छैन",
        item3: "नेपालमा आधारित सहायता — हामीलाई स्थानीय भाडा बजार थाहा छ",
        item4: "पारदर्शी मूल्य — जे देख्नुहुन्छ त्यही मालिकले लिन्छ",
        contactHeading: "सम्पर्क गर्नुहोस्",
        location: "काठमाडौं उपत्यका, नेपाल",
        hours: "सोम–शनि · स्थानीय टिम · भाडावाल र मालिक दुवैलाई स्वागत छ",
        feature1Title: "प्रमाणित सूचीहरू",
        feature1Desc: "प्रत्येक सूची गुणस्तर, फोटो र मुख्य विवरणका लागि समीक्षा गरिन्छ",
        feature2Title: "मालिकसँग सिधा सम्पर्क",
        feature2Desc: "छिटो निर्णयका लागि मालिकसँग सिधै कुरा गर्नुहोस्",
        feature3Title: "दलाल शुल्क छैन",
        feature3Desc: "भाडावाल-मालिक बीच पारदर्शी संवादका लागि बनाइएको",
        feature4Title: "नेपालमा स्थानीय सहायता",
        feature4Desc: "सहायता चाहिन्छ? नेपालमा जहाँबाट पनि support@gharbhada.org मा सम्पर्क गर्नुहोस्",
      },
      testimonials: {
        title: "पहिला भाडावाल र मालिकहरूले भनेका छन्",
        subtitle: "नेपालभर घरभाडाका पहिला प्रयोगकर्ताहरूको इमानदार प्रतिक्रिया",
        role1: "भाडावाल · काठमाडौं",
        role2: "सम्पत्ति मालिक · पोखरा",
        role3: "भाडावाल · ललितपुर",
      },
      cta: {
        title: "नेपालमा आफ्नो अर्को घर खोज्न तयार हुनुहुन्छ?",
        subtitle: "प्रमाणित मालिकहरूका वास्तविक सूचीहरू हेर्नुहोस् — दलाल छैन, झञ्झट छैन।",
        btn: "सम्पत्तिहरू हेर्नुहोस्",
      },
      featured: {
        title: "विशेष प्रमाणित भाडाका सम्पत्तिहरू",
        subtitle: "लाइभ हुनुअघि हाम्रो टिमद्वारा समीक्षा गरिएका",
        viewAll: "सबै सूचीहरू हेर्नुहोस्",
        viewDetails: "विवरण हेर्नुहोस्",
        perMonth: "प्रति महिना",
        bed: "कोठा",
        bath: "बाथरुम",
        sqft: "वर्ग फिट",
        verified: "प्रमाणित",
        unverified: "अप्रमाणित",
        loading: "विशेष सूचीहरू लोड हुँदैछ…",
        noListings: "अहिले कुनै विशेष सूची छैन।",
      },
    },
    footer: {
      tagline: "नेपालको सिधा भाडा प्लेटफर्म",
      desc: "प्रमाणित सूचीहरू। मालिकसँग सम्पर्क। दलाल आवश्यक छैन। नेपालको भाडा बजारका लागि बनाइएको।",
      quickLinks: "छिटो लिङ्कहरू",
      browse: "सम्पत्तिहरू हेर्नुहोस्",
      list: "सम्पत्ति सूचीबद्ध गर्नुहोस्",
      becomeHost: "मालिक बन्नुहोस्",
      helpCenter: "सहायता केन्द्र",
      support: "सहायता",
      contact: "सम्पर्क गर्नुहोस्",
      safety: "सुरक्षा केन्द्र",
      community: "सामुदायिक दिशानिर्देश",
      terms: "सेवाका सर्तहरू",
      contactSection: "सम्पर्क",
      location: "काठमाडौं उपत्यका, नेपाल",
      hours: "सोम–शनि · स्थानीय भाडा सहायता",
      welcome: "भाडावाल र मालिक दुवैलाई स्वागत छ",
      copyright: "© २०२६ घरभाडा। सबै अधिकार सुरक्षित।",
      privacy: "गोपनीयता नीति",
      cookie: "कुकी नीति",
    },
    findProperty: {
      searchPlaceholder: "स्थानले खोज्नुहोस् (जस्तै, काठमाडौं, ठमेल, ललितपुर)",
      all: "सबै",
      filter: "फिल्टर",
      filters: "फिल्टरहरू",
      priceRange: "मूल्य दायरा",
      propertyType: "सम्पत्तिको प्रकार",
      any: "जुनसुकै",
      bedrooms: "शयनकोठाहरू",
      bathrooms: "बाथरुमहरू",
      amenities: "सुविधाहरू",
      showMore: "थप देखाउनुहोस्",
      showLess: "कम देखाउनुहोस्",
      clearFilters: "फिल्टर हटाउनुहोस्",
      perMonth: "प्रति महिना",
      bed: "कोठा",
      bath: "बाथरुम",
      sqft: "वर्ग फिट",
      viewDetails: "विवरण हेर्नुहोस्",
      loading: "सम्पत्तिहरू लोड हुँदैछ…",
      noProperties: "तपाईंको फिल्टरसँग मेल खाने कुनै सम्पत्ति फेला परेन।",
      applyNow: "आवेदन दिनुहोस्",
      message: "सन्देश",
      ownerPromo: {
        ariaLabel: "मालिक सूची प्रचार",
        ctaPrimary: "सम्पत्ति निःशुल्क सूचीबद्ध गर्नुहोस्",
        ctaSecondary: "निःशुल्क सूची कसरी काम गर्छ",
        inlineCta: "घरको मालिक हुनुहुन्छ? निःशुल्क सूचीबद्ध गर्नुहोस्",
        empty: {
          eyebrow1: "विश्वसनीय मालिक कार्यक्रम",
          eyebrow2: "सुरक्षित सूची, शून्य दलाली",
          eyebrow3: "मालिक पहिलो, भाडावाल मैत्री",
          headline1: "दलाली शुल्क छैन। सूची शुल्क छैन। आफ्नो घर निःशुल्क भाडामा दिन सुरु गर्नुहोस्।",
          headline2: "केही मिनेटमै सम्पत्ति अपलोड गर्नुहोस् र बिचौलिया खर्च बिना सिधै भाडामा दिनुहोस्।",
          headline3: "निःशुल्क सूची र सुरक्षित मालिक नियन्त्रणसँग आफ्नो भाडा आम्दानी बढाउनुहोस्।",
          body1: "घरभाडाले पारदर्शी मूल्य र सुरक्षित सन्देश सुविधासहित मालिकलाई भाडावालसम्म सिधा पहुँच दिन्छ।",
          body2: "निःशुल्क मालिक खाता बनाउनुहोस् र प्लेटफर्म वा दलाल शुल्क बिना सूची प्रकाशित गर्नुहोस्।",
          body3: "तपाईंले सूची, मूल्य र कुराकानीमा पूर्ण नियन्त्रण राख्नुहुन्छ, हामी सुरक्षित कार्यप्रवाहमा साथ दिन्छौं।",
          point1: "१००% निःशुल्क सम्पत्ति सूची",
          point2: "मालिक र भाडावाल दुवैका लागि दलाली शुल्क छैन",
          point3: "सूचीदेखि सोधपुछसम्म निःशुल्क भाडा कार्यप्रवाह",
        },
        compact: {
          eyebrow1: "आफ्ना सूचीहरू अझ बढाउनुहोस्",
          eyebrow2: "विश्वसनीय मालिक कार्यक्रम",
          eyebrow3: "दलाली बिना भाडा विस्तार गर्नुहोस्",
          headline1: "० दलाली शुल्क र ० सूची शुल्कमा अझ धेरै सम्पत्ति सूचीबद्ध गर्नुहोस्",
          headline2: "आजै अर्को घर थप्नुहोस् र सिधा मालिक दृश्यताबाट छिटो भाडावालसम्म पुग्नुहोस्।",
          headline3: "थप सम्पत्ति, उही वाचा: शून्य दलाली र निःशुल्क सूची।",
          body1: "अर्को सम्पत्ति थपेर सुरक्षित इन-एप संवादसँग आफ्नो भाडा प्रवाह सक्रिय राख्नुहोस्।",
          body2: "निःशुल्क सूचीसँग विस्तार गर्नुहोस् र नेपालभरका भाडावाललाई विश्वसनीय घर देखाउनुहोस्।",
          body3: "एकै ठाउँबाट सूची, व्यवस्थापन र प्रतिक्रिया दिनुहोस् र दुवै पक्षको लागत कम राख्नुहोस्।",
          point1: "हरेक नयाँ सम्पत्तिका लागि निःशुल्क सूची",
          point2: "मालिक र भाडावालबीच सिधा संवाद",
          point3: "सफल भाडामा कुनै कमिसन छैन",
        },
      },
      categories: {
        house: "घर",
        apartment: "अपार्टमेन्ट",
        villa: "भिल्ला",
        studio: "स्टुडियो",
        cottage: "कुटिर",
        land: "जग्गा",
        commercial: "व्यावसायिक",
        condo: "कन्डो",
        cabin: "क्याबिन",
        room: "कोठा",
        officeSpace: "अफिस स्पेस",
      },
    },
    login: {
      welcomeBack: "स्वागत छ",
      subtitle: "आफ्नो घरभाडा खातामा साइन इन गर्नुहोस्",
      whyTitle: "घरभाडा किन छान्ने?",
      feature1Title: "स्मार्ट सम्पत्ति खोज",
      feature1Desc: "उन्नत फिल्टर र स्थानमा आधारित खोजले सम्पत्तिहरू फेला पार्नुहोस्",
      feature2Title: "प्रमाणित सूचीहरू",
      feature2Desc: "सबै सम्पत्तिहरू प्रामाणिकता र शुद्धताका लागि प्रमाणित छन्",
      feature3Title: "सिधा सञ्चार",
      feature3Desc: "सम्पत्ति मालिकसँग सिधा जोडिनुहोस् र भ्रमण तालिका बनाउनुहोस्",
      feature4Title: "स्मार्ट सम्पत्ति खोज",
      feature4Desc: "अघिल्ला भाडावालहरूको समीक्षा र मूल्याङ्कन पढ्नुहोस्",
      email: "इमेल",
      password: "पासवर्ड",
      emailPlaceholder: "उदा. johndoe@xyz.com",
      passwordPlaceholder: "कृपया पासवर्ड लेख्नुहोस्",
      rememberMe: "मलाई याद राख्नुहोस्",
      forgotPassword: "पासवर्ड बिर्सनुभयो?",
      signingIn: "साइन इन हुँदैछ…",
      signIn: "साइन इन",
      emailRequired: "इमेल आवश्यक छ",
      emailInvalid: "मान्य इमेल वा पासवर्ड लेख्नुहोस्",
      passwordRequired: "पासवर्ड आवश्यक छ",
    },
    signup: {
      welcome: "घरभाडामा स्वागत छ",
      subtitle: "नेपालको सबैभन्दा विश्वसनीय भाडा सम्पत्ति प्लेटफर्म",
      feature1Title: "स्मार्ट सम्पत्ति खोज",
      feature1Desc: "नेपालभर स्थान, मूल्य, र सुविधाले उन्नत फिल्टरसहित सम्पत्तिहरू फेला पार्नुहोस्",
      feature2Title: "मनपर्नेहरू सुरक्षित गर्नुहोस्",
      feature2Desc: "मनपर्ने सम्पत्तिहरू बुकमार्क गर्नुहोस् र उस्तै उपलब्ध भएमा सूचना पाउनुहोस्",
      feature3Title: "सिधा सञ्चार",
      feature3Desc: "बिचौलिया वा अतिरिक्त शुल्क बिना सम्पत्ति मालिकसँग सिधा जोडिनुहोस्",
      feature4Title: "प्रमाणित सूचीहरू",
      feature4Desc: "प्रामाणिक फोटो र सही जानकारीसहित प्रमाणित सम्पत्तिहरू हेर्नुहोस्",
      feature5Title: "भ्रमण तालिका बनाउनुहोस्",
      feature5Desc: "हाम्रो एकीकृत तालिका प्रणालीसँग सुविधाजनक समयमा सम्पत्ति भ्रमण बुक गर्नुहोस्",
      feature6Title: "बजार अन्तर्दृष्टि",
      feature6Desc: "सूचित निर्णयका लागि भाडा मूल्य प्रवृत्ति र बजार विश्लेषण पहुँच गर्नुहोस्",
      firstName: "पहिलो नाम",
      firstNamePlaceholder: "उदा. राम",
      firstNameRequired: "पहिलो नाम आवश्यक छ",
      lastName: "थर",
      lastNamePlaceholder: "उदा. श्रेष्ठ",
      lastNameRequired: "थर आवश्यक छ",
      email: "इमेल",
      emailPlaceholder: "उदा. johndoe@xyz.com",
      emailRequired: "इमेल आवश्यक छ",
      emailInvalid: "मान्य इमेल लेख्नुहोस्",
      phone: "फोन नम्बर",
      phonePlaceholder: "उदा. ९८४१२३४५६७",
      phoneRequired: "फोन नम्बर आवश्यक छ",
      phoneInvalid: "मान्य फोन नम्बर लेख्नुहोस्",
      gender: "लिङ्ग",
      genderSelect: "--कृपया छान्नुहोस्--",
      genderMale: "पुरुष",
      genderFemale: "महिला",
      genderOther: "अन्य",
      genderNone: "नभन्न मन लाग्दैन",
      genderRequired: "कृपया आफ्नो लिङ्ग छान्नुहोस्",
      role: "म हुँ",
      roleSelect: "--कृपया छान्नुहोस्--",
      roleRenter: "भाडावाल - सम्पत्ति खोज्दैछु",
      roleOwner: "सम्पत्ति मालिक - सम्पत्ति सूचीबद्ध गर्दैछु",
      roleRequired: "कृपया आफ्नो भूमिका छान्नुहोस्",
      createPassword: "पासवर्ड बनाउनुहोस्",
      passwordPlaceholder: "कृपया पासवर्ड लेख्नुहोस्",
      passwordRequired: "पासवर्ड आवश्यक छ",
      passwordInvalid: "पासवर्डमा कम्तीमा १ ठूलो, १ सानो अक्षर, १ अंक, १ चिह्न र ८ अक्षर हुनुपर्छ",
      confirmPassword: "पासवर्ड पुष्टि गर्नुहोस्",
      passwordsMustMatch: "पासवर्डहरू मेल खाएनन्",
      agreeTerms: "म सेवाका सर्तहरू र गोपनीयता नीतिसँग सहमत छु",
      agreeRequired: "जारी राख्न नियम र सर्तहरू स्वीकार गर्नुहोस्।",
      createAccount: "खाता बनाउनुहोस्",
      creating: "खाता बनाइँदैछ…",
      hasAccount: "पहिलेदेखि खाता छ?",
      loginLink: "लगइन",
    },
    oauthProfile: {
      title: "आफ्नो प्रोफाइल पूरा गर्नुहोस्",
      subtitle: "Google खाताको सेटअप पूरा गर्न यी विवरणहरू भर्नुहोस्।",
      stepLabel: "चरण २ मध्ये २",
      formTitle: "खाता विवरण",
      firstName: "पहिलो नाम",
      firstNamePlaceholder: "पहिलो नाम लेख्नुहोस्",
      firstNameRequired: "पहिलो नाम आवश्यक छ।",
      lastName: "थर",
      lastNamePlaceholder: "थर लेख्नुहोस्",
      lastNameRequired: "थर आवश्यक छ।",
      phone: "फोन नम्बर",
      phonePlaceholder: "98XXXXXXXX",
      phoneRequired: "फोन नम्बर आवश्यक छ।",
      phoneHint: "कम्तीमा ७ अंक लेख्नुहोस्।",
      countryCodeRequired: "देश कोड आवश्यक छ।",
      gender: "लिङ्ग",
      genderSelect: "लिङ्ग छान्नुहोस्",
      genderMale: "पुरुष",
      genderFemale: "महिला",
      genderOther: "अन्य",
      genderNone: "नभन्न मन लाग्दैन",
      genderRequired: "कृपया लिङ्ग छान्नुहोस्।",
      role: "भूमिका",
      roleOwner: "सम्पत्ति मालिक",
      roleRenter: "भाडावाल",
      roleRequired: "कृपया भूमिका छान्नुहोस्।",
      submit: "खाता पूरा गर्नुहोस्",
      saving: "सुरक्षित हुँदैछ...",
      tipVerified: "सुरक्षित सेसन हस्तान्तरणसहित प्रमाणित खाता प्रक्रिया",
      tipPrivacy: "तपाईंका विवरण विश्वसनीय भाडा मिलानका लागि मात्र प्रयोग हुन्छन्",
      tipEditable: "यी विवरणहरू पछि प्रोफाइलबाट परिवर्तन गर्न सकिन्छ",
      submitFailed: "प्रोफाइल पूरा गर्न सकिएन। फेरि प्रयास गर्नुहोस्।",
      networkError: "नेटवर्क त्रुटि भयो। फेरि प्रयास गर्नुहोस्।",
    },
    emailVerificationBanner: {
      title: "आफ्नो इमेल प्रमाणित गर्नुहोस्",
      subtitle: "खाता सुरक्षाका लागि कृपया इमेल प्रमाणित गर्नुहोस्।",
      codePlaceholder: "६-अंकको कोड लेख्नुहोस्",
      verifyBtn: "प्रमाणित गर्नुहोस्",
      verifying: "प्रमाणित हुँदैछ...",
      resendBtn: "कोड फेरि पठाउनुहोस्",
      resending: "पठाउँदै...",
      resendIn: "{{seconds}}s पछि फेरि पठाउनुहोस्",
      invalidCode: "कृपया मान्य ६-अंकको कोड लेख्नुहोस्।",
      verifyFailed: "कोड प्रमाणित गर्न सकिएन।",
      resendFailed: "कोड फेरि पठाउन सकिएन।",
      verified: "इमेल सफलतापूर्वक प्रमाणित भयो।",
      codeResent: "नयाँ प्रमाणिकरण कोड पठाइएको छ।",
      requestTimeout: "अनुरोध समयमै पूरा भएन। फेरि प्रयास गर्नुहोस्।",
      networkError: "नेटवर्क त्रुटि भयो। फेरि प्रयास गर्नुहोस्।",
    },
    pages: {
      helpCenter: "सहायता केन्द्र",
      communityGuidelines: "सामुदायिक दिशानिर्देश",
      safetyCenter: "सुरक्षा केन्द्र",
      contactUs: "सम्पर्क गर्नुहोस्",
      privacyPolicy: "गोपनीयता नीति",
      termsOfService: "सेवाका सर्तहरू",
      cookiePolicy: "कुकी नीति",
      back: "← पछाडि",
      contactSupport: "support@gharbhada.org मा इमेल गर्नुहोस्",
      stillNeedHelp: "अझै सहायता चाहिन्छ?",
      stillNeedHelpDesc: "हाम्रो नेपालमा आधारित सहायता टिम सोम–शनि उपलब्ध छ।",
      reportIssue: "अहिले नै समस्या रिपोर्ट गर्नुहोस्",
      reportIssueDesc: "हाम्रो टिम सुरक्षा रिपोर्टलाई गम्भीरताले लिन्छ।",
      reportBtn: "support@gharbhada.org मा रिपोर्ट गर्नुहोस्",
      contactQuestion: "यी दिशानिर्देशबारे प्रश्न छ?",
      contactQuestionDesc: "हाम्रो टिम कुनै पनि कुरा स्पष्ट पार्न खुसी छ।",
      contactCta: "सम्पर्क गर्नुहोस्",
    },
      renterDashboard: {
        welcomeSubtitle: "स्वागत छ! यहाँ तपाईंका भाडामा लिएका सम्पत्तिहरूको अवस्था छ।",
        noActiveRental: "कुनै सक्रिय भाडा छैन",
        noActiveRentalDesc: "तपाईंले अहिलेसम्म कुनै सम्पत्ति भाडामा लिनुभएको छैन। उपलब्ध सम्पत्तिहरू हेर्नुहोस्।",
        browseBtn: "उपलब्ध भाडाहरू हेर्नुहोस्",
        myApplications: "मेरा आवेदनहरू",
        noApplications: "तपाईंले अहिलेसम्म कुनै भाडा आवेदन पेश गर्नुभएको छैन।",
        latestUpdates: "मालिकबाट नवीनतम अपडेटहरू",
        ownerLabel: "मालिक:",
        dashboardTitle: "ड्यासबोर्ड",
        welcomeBackName: "स्वागत छ,",
        notifications: "सूचनाहरू",
        noNotifications: "कुनै नयाँ अपडेट छैन।",
        activeLease: "सक्रिय भाडा",
        beds: "कोठाहरू",
        bath: "बाथरूम",
        sqft: "वर्ग फिट",
        monthlyRent: "मासिक भाडा",
        payRent: "भाडा तिर्नुहोस्",
        nextPaymentDue: "अर्को भुक्तानी मिति",
        dueIn: "मिति",
        days: "दिनमा",
        leaseEnds: "भाडा सम्झौता समाप्त",
        monthsRemaining: "महिना बाँकी",
        landlord: "घरधनी",
        ownerRequestedTermination: "मालिकले भाडा समाप्तिको अनुरोध गर्नुभयो",
        reason: "कारण:",
        approveTermination: "समाप्ति स्वीकार गर्नुहोस्",
        maintenance: "मर्मत",
        lease: "भाडा सम्झौता",
        endLease: "भाडा समाप्त गर्नुहोस्",
        cancelRequest: "अनुरोध रद्द गर्नुहोस्",
        ownerRequested: "मालिकको अनुरोध",
        contact: "सम्पर्क",
        writeReview: "समीक्षा लेख्नुहोस्",
        requestTerminationTitle: "भाडा समाप्तिको अनुरोध",
        terminationNote: "तपाईंका घरधनीले यो अनुरोध स्वीकार गर्नुपर्छ। स्वीकृत भएपछि भाडा तुरुन्त समाप्त हुन्छ।",
        terminationReasonLabel: "समाप्तिको कारण",
        terminationPlaceholder: "कृपया किन भाडा समाप्त गर्न चाहनुहुन्छ भन्नुहोस्...",
        terminationHint: "आफ्नो कारण स्पष्ट र सम्मानजनक तरिकाले लेख्नुहोस्।",
        cancel: "रद्द गर्नुहोस्",
        submitting: "पेश गर्दै...",
        submitRequest: "अनुरोध पेश गर्नुहोस्",
        writeReviewTitle: "समीक्षा लेख्नुहोस्",
        propertyLabel: "सम्पत्ति",
        statusApproved: "स्वीकृत",
        statusRejected: "अस्वीकृत",
        statusUnderReview: "समीक्षाधीन",
        noteApproved: "तपाईंको आवेदन स्वीकृत भयो!",
        noteRejected: "तपाईंको आवेदन स्वीकार गरिएन।",
        noteUnderReview: "मालिकको निर्णयको प्रतीक्षा गर्दै।",
      },
      ownerDashboard: {
        welcomeSubtitle: "स्वागत छ! यहाँ तपाईंका सम्पत्तिहरूको अवस्था छ।",
        addProperty: "सम्पत्ति थप्नुहोस्",
        totalProperties: "कुल सम्पत्तिहरू",
        activeRentals: "सक्रिय भाडाहरू",
        activeApartments: "सक्रिय अपार्टमेन्टहरू",
        activeApartmentsDesc: "हाल भाडामा दिइएका (कुल सम्पत्तिको अंश)",
        pendingInquiries: "लम्बित सोधपुछहरू",
        estRevenue: "अनुमानित मासिक आय",
        propertiesTab: "सम्पत्तिहरू",
        applicationsTab: "आवेदनहरू",
        appFormBtn: "आवेदन फारम",
        colNum: "#",
        colProperties: "सम्पत्तिहरू",
        colStatus: "अवस्था",
        colRenter: "भाडावाल",
        colPrice: "मूल्य",
        colSettings: "सेटिङ",
        noProperties: "कुनै सम्पत्ति फेला परेन। सूची हेर्नका लागि सम्पत्ति थप्नुहोस्।",
        statusRented: "भाडामा दिइएको",
        statusActive: "सक्रिय",
        statusUnlisted: "सूचीबाहिर",
        statusAvailable: "उपलब्ध",
        renterRequestedTermination: "भाडावालले समाप्ति अनुरोध गर्यो",
        terminationPending: "समाप्ति लम्बित",
        notRented: "भाडामा दिइएको छैन",
        viewDetails: "विवरण हेर्नुहोस्",
        endLease: "भाडा समाप्त गर्नुहोस्",
        noApplications: "अहिलेसम्म कुनै भाडा आवेदन छैन।",
        colProperty: "सम्पत्ति",
        colApplicant: "आवेदक",
        colSubmitted: "पेश गरिएको",
        colAction: "कार्य",
        view: "हेर्नुहोस्",
        applicant: "आवेदक",
        name: "नाम",
        email: "इमेल",
        phone: "फोन",
        appAnswers: "आवेदन उत्तरहरू",
        submittedDocs: "पेश गरिएका कागजातहरू",
        rejectionReasonLabel: "अस्वीकृतिको कारण:",
        reasonForRejection: "अस्वीकृतिको कारण",
        reject: "अस्वीकार गर्नुहोस्",
        approveCreateRental: "स्वीकृत गर्नुहोस् र भाडा सिर्जना गर्नुहोस्",
        confirmRejection: "अस्वीकृति पुष्टि गर्नुहोस्",
        close: "बन्द गर्नुहोस्",
        cancel: "रद्द गर्नुहोस्",
        property: "सम्पत्ति",
        currentTenant: "हालको भाडावाल",
        renterLabel: "भाडावाल",
        reasonForTermination: "समाप्तिको कारण",
        noReasonProvided: "कुनै कारण उल्लेख गरिएको छैन",
        denyRequest: "अनुरोध अस्वीकार गर्नुहोस्",
        approveTermination: "समाप्ति स्वीकार गर्नुहोस्",
        cancelRequest: "अनुरोध रद्द गर्नुहोस्",
        denyTerminationTitle: "समाप्ति अनुरोध अस्वीकार गर्नुहोस्",
        reasonForDenial: "अस्वीकृतिको कारण",
        denyNote: "तपाईं भाडावालको समाप्ति अनुरोध अस्वीकार गर्न लाग्नुहुन्छ। स्पष्ट कारण दिनुहोस्।",
        denialPlaceholder: "किन यो समाप्ति अनुरोध अस्वीकार गर्दै हुनुहुन्छ भन्नुहोस्...",
        denyingHint: "यो कारण भाडावाललाई जानकारी गराइनेछ",
        denying: "अस्वीकार गर्दै...",
        renterRequestedModal: "भाडावालले भाडा समाप्तिको अनुरोध गर्यो",
        ownerRequestedModal: "भाडा समाप्ति अनुरोध",
        terminationNoteRenter: "भाडावालले भाडा समाप्तिको अनुरोध गरेका छन्। माथिको कारण हेर्नुहोस्।",
        terminationNoteOwner: "तपाईंले भाडा समाप्तिको अनुरोध गर्नुभयो। भाडावालले स्वीकार गर्न सक्छन्।",
        loading: "लोड हुँदै...",
        previewNotSupported: "यो फाइल प्रिभ्यू समर्थित छैन।",
        docPreviewTitle: "कागजात प्रिभ्यू",
        kycRequired: "पहिचान प्रमाणीकरण आवश्यक छ",
        kycRequiredMsg: "सम्पत्ति सूचीबद्ध गर्न KYC प्रमाणीकरण पूरा गर्नुहोस्।",
        kycPending: "KYC समीक्षाधीन",
        kycPendingMsg: "तपाईंका कागजातहरू समीक्षा भइरहेका छन्।",
        kycRejected: "KYC अस्वीकृत",
        kycRejectedMsg: "तपाईंको KYC अस्वीकृत भयो। सही कागजातसहित पुनः पेश गर्नुहोस्।",
        kycResubmit: "पुनः पेश आवश्यक",
        kycResubmitMsg: "कृपया KYC कागजात अद्यावधिक गरेर पुनः पेश गर्नुहोस्।",
        kycVerifyNow: "अहिले प्रमाणित गर्नुहोस्",
        kycResubmitBtn: "पुनः पेश गर्नुहोस्",
        // Section titles
        dashboard: "ड्यासबोर्ड",
        overviewSection: "सिंहावलोकन",
        activeRentalsSection: "सक्रिय भाडाहरू",
        appFormSection: "आवेदन फारम",
        accountSettings: "खाता सेटिङ",
        // Sidebar
        mainNavLabel: "मुख्य",
        configNavLabel: "कन्फिगरेसन",
        propertyOwnerRole: "सम्पत्ति मालिक",
        // Topbar chips
        kycPendingChip: "KYC प्रक्रियामा",
        verifyIdentityChip: "पहिचान प्रमाणित गर्नुहोस्",
        verifiedChip: "प्रमाणित",
        // Greeting
        greetingPrefix: "स्वागत छ",
        greetingSnapshot: "यहाँ तपाईंका सम्पत्तिहरू र गतिविधिको सारांश छ।",
        // Metric sub-labels
        listedLabel: "सूचीबद्ध",
        unlistedLabel: "असूचीबद्ध",
        currentlyOccupied: "हाल भाडामा",
        noMonthlyData: "मासिक डेटा उपलब्ध छैन",
        // Quick actions
        manageProperties: "सम्पत्तिहरू व्यवस्थापन",
        reviewApplications: "आवेदनहरू समीक्षा",
        addNewProperty: "नयाँ सम्पत्ति थप्नुहोस्",
        pendingBadge: "लम्बित",
        // Recent apps card
        recentApplications: "हालका आवेदनहरू",
        viewAll: "सबै हेर्नुहोस् \u2192",
        // Properties section
        noPropertiesYet: "अहिले सम्म सम्पत्ति छैन",
        noPropertiesMsg: "आवेदन पाउन सुरु गर्न पहिलो सम्पत्ति सूचीबद्ध गर्नुहोस्।",
        listAProperty: "सम्पत्ति सूचीबद्ध गर्नुहोस्",
        perMonth: "/महिना",
        terminationPendingTitle: "समाप्ति अनुरोध पेन्डिङ",
        editPropertyTitle: "सम्पत्ति सम्पादन",
        propertySingular: "सम्पत्ति",
        propertyPlural: "सम्पत्तिहरू",
        // Filter tabs
        filterAll: "सबै",
        filterPending: "लम्बित",
        filterApproved: "स्वीकृत",
        filterRejected: "अस्वीकृत",
        noAppsFromRenters: "भाडावालहरूका आवेदनहरू यहाँ देखिनेछन्।",
        noAppsFiltered: "हाल यस फिल्टरमा कुनै आवेदन छैन।",
        // Active Rentals section
        noActiveRentals: "कुनै सक्रिय भाडा छैन",
        noActiveRentalsMsg: "जब कुनै सम्पत्ति भाडामा जान्छ, यहाँ देखिनेछ।",
        statusRentedPill: "भाडामा",
        tenantLabel: "भाडावाल",
        monthlyRentLabel: "मासिक भाडा",
        leaseStartLabel: "भाडा सुरु",
        leaseEndLabel: "भाडा अन्त्य",
        // Application Form section
        appFormQuestions: "आवेदन फारम प्रश्नहरू",
        appFormStandardNote: "मानक खण्डहरू (व्यक्तिगत जानकारी, रोजगार, भाडा विवरण, सन्दर्भ, कागजातहरू) सधैं समावेश हुन्छन्। भाडावालहरूले जवाफ दिनुपर्ने अतिरिक्त प्रश्नहरू थप्नुहोस्।",
        noCustomQuestions: "अहिलेसम्म कुनै कस्टम प्रश्न छैन। तल थप्नुहोस्।",
        addAQuestion: "प्रश्न थप्नुहोस्",
        questionLabelField: "प्रश्न / लेबल",
        typeLabel: "प्रकार",
        shortText: "छोटो पाठ",
        longText: "लामो पाठ",
        numberType: "संख्या",
        yesNo: "हो / होइन",
        fileUpload: "फाइल अपलोड",
        requiredLabel: "अनिवार्य",
        addQuestion: "प्रश्न थप्नुहोस्",
        saveTemplate: "टेम्प्लेट सेभ गर्नुहोस्",
        savingLabel: "सेभ हुँदैछ...",
        // Account Settings section
        profileSection: "प्रोफाइल",
        fullNameLabel: "पूरा नाम",
        accountRoleLabel: "खाता भूमिका",
        editProfile: "प्रोफाइल सम्पादन",
        identityVerificationTitle: "पहिचान प्रमाणीकरण (KYC)",
        identityVerifiedStatus: "पहिचान प्रमाणित",
        underReviewStatus: "समीक्षामा",
        verificationRejectedStatus: "प्रमाणीकरण अस्वीकृत",
        notSubmittedStatus: "पेश गरिएको छैन",
        kycVerifiedDesc: "तपाईंको पहिचान प्रमाणित भएको छ। सबै मालिक सुविधाहरूमा पूर्ण पहुँच छ।",
        kycUnderReviewDesc: "तपाईंका कागजातहरू समीक्षामा छन्। सामान्यतः १\u20132 कार्यदिन लाग्छ।",
        kycRejectedDesc: "तपाईंको पेश नामञ्जुर भयो। सही कागजातसहित पुनः पेश गर्नुहोस्।",
        kycNotSubmittedDesc: "सम्पत्ति सूचीबद्ध गर्न आफ्नो पहिचान कागजात पेश गर्नुहोस्।",
        checkStatus: "स्थिति जाँच गर्नुहोस्",
        resubmitKyc: "KYC पुनः पेश",
        startKyc: "KYC सुरु गर्नुहोस्",
        securitySection: "सुरक्षा",
        passwordLabel: "पासवर्ड",
        changePassword: "पासवर्ड परिवर्तन",
        dangerZone: "खतरनाक क्षेत्र",
        signOutMsg: "साइन आउट गर्दा तपाईंको स्थानीय सत्र डेटा हट्नेछ।",
        signOut: "साइन आउट",
        // Mobile bottom nav
        overviewTab: "सिंहावलोकन",
        appsTab: "आवेदन",
        moreTab: "थप",
        // Modals
        appModalTitlePrefix: "आवेदन",
        previewLoadingLabel: "लोड हुँदैछ...",
        previewBtn: "पूर्वावलोकन",
        rejectPlaceholder: "यो आवेदन अस्वीकार गर्नुको कारण बताउनुहोस्...",
        appliedLabel: "आवेदन गरिएको",
        untilLabel: "सन्दर्भ",
      },
    kyc: {
      title: "पहिचान प्रमाणीकरण (KYC)",
      subtitle: "पूर्ण पहुँचका लागि आफ्नो पहिचान प्रमाणित गर्नुहोस्।",
      stepPersonal: "व्यक्तिगत जानकारी",
      stepIdentity: "परिचयपत्र",
      stepUpload: "कागजात अपलोड",
      stepReview: "समीक्षा र पेश",
      forRole: "पूर्ण पहुँच खोल्न र {{role}} सँग विश्वास निर्माण गर्न आफ्नो पहिचान प्रमाणित गर्नुहोस्।",
      roleRenterPlural: "सम्पत्ति मालिकहरू",
      roleOwnerPlural: "भाडावालहरू",
      fullName: "पूरा नाम",
      dateOfBirth: "जन्म मिति",
      nationality: "राष्ट्रियता",
      permanentAddress: "स्थायी ठेगाना",
      currentAddress: "हालको ठेगाना",
      currentAddressIfDifferent: "हालको ठेगाना (माथिको भन्दा फरक भएमा)",
      documentType: "कागजातको प्रकार",
      documentNumber: "कागजात नम्बर",
      citizenship: "नागरिकता कार्ड",
      passport: "राहदानी",
      drivingLicense: "सवारी चालक अनुमतिपत्र",
      voterId: "मतदाता परिचयपत्र",
      ownerDetails: "मालिक विवरण",
      optionalRecommended: "(वैकल्पिक तर सिफारिस गरिएको)",
      panNumber: "प्यान नम्बर",
      bankName: "बैंकको नाम",
      bankAccount: "बैंक खाता नम्बर",
      docFront: "कागजातको अगाडिको भाग",
      docBack: "कागजातको पछाडिको भाग",
      selfie: "सेल्फी / जीवित फोटो",
      uploadTitle: "कागजात अपलोड",
      reviewTitle: "समीक्षा र पेश",
      submitConfirm: "पेश गर्दा तपाईंले सबै जानकारी र कागजात वास्तविक तथा तपाईंकै भएको पुष्टि गर्नुहुन्छ। झुटो कागजात पेश गर्नु सेवाका सर्तहरूको उल्लङ्घन हो र सम्बन्धित निकायमा जानकारी गराउन सकिन्छ।",
      acceptedFormats: "स्वीकृत ढाँचा: JPEG, PNG, WEBP, PDF। प्रति फाइल अधिकतम १० MB। कागजात स्पष्ट र पूरा देखिनुपर्छ।",
      clickToUpload: "अपलोड गर्न क्लिक गर्नुहोस्",
      dragDrop: "वा ड्र्याग र ड्रप गर्नुहोस्",
      uploaded: "अपलोड गरियो",
      continue: "अगाडि बढ्नुहोस्",
      back: "फिर्ता",
      cancel: "रद्द गर्नुहोस्",
      required: "आवश्यक",
      fullNameRequired: "पूरा नाम आवश्यक छ।",
      dateOfBirthRequired: "जन्म मिति आवश्यक छ।",
      permanentAddressRequired: "स्थायी ठेगाना आवश्यक छ।",
      documentNumberRequired: "कागजात नम्बर आवश्यक छ।",
      documentFrontRequired: "कागजातको अगाडिको भाग आवश्यक छ।",
      selfieRequired: "सेल्फी आवश्यक छ।",
      asOnId: "तपाईंको परिचयपत्रमा देखिएअनुसार",
      addressPlaceholder: "वडा नं., नगरपालिका / गाउँपालिका, जिल्ला, प्रदेश",
      currentAddressPlaceholder: "वैकल्पिक — स्थायी ठेगाना भन्दा फरक भएमा मात्र",
      documentNumberPlaceholder: "जस्तै 12-01-76-12345",
      panPlaceholder: "जस्तै 123456789",
      bankNamePlaceholder: "जस्तै नेपाल बैंक लिमिटेड",
      bankAccountPlaceholder: "तपाईंको बैंक खाता नम्बर",
      uploadFrontHint: "तपाईंको {{document}} को अगाडिको भाग अपलोड गर्नुहोस्",
      uploadBackHint: "वैकल्पिक — लागू भएमा समावेश गर्नुहोस्",
      uploadSelfieHint: "आफ्नो परिचयपत्र अनुहारसँगै समातेको स्पष्ट र राम्रो प्रकाश भएको फोटो राख्नुहोस्।",
      reviewFullName: "पूरा नाम",
      reviewDob: "जन्म मिति",
      reviewNationality: "राष्ट्रियता",
      reviewPermanentAddress: "स्थायी ठेगाना",
      reviewCurrentAddress: "हालको ठेगाना",
      reviewDocType: "कागजातको प्रकार",
      reviewDocNumber: "कागजात नम्बर",
      reviewPan: "प्यान नम्बर",
      reviewBank: "बैंकको नाम",
      reviewAccount: "खाता नं.",
      reviewDocFront: "कागजात अगाडिको भाग",
      reviewDocBack: "कागजात पछाडिको भाग",
      reviewSelfie: "सेल्फी",
      dash: "—",
      loading: "तपाईंको KYC स्थिति लोड हुँदैछ…",
      submit: "KYC पेश गर्नुहोस्",
      submitting: "पेश गर्दै…",
      successTitle: "KYC पेश गरिएको — समीक्षाधीन",
      successMsg: "तपाईंका परिचय कागजातहरू पेश गरिएका छन्। हाम्रो टिमले १–२ कार्यदिनभित्र समीक्षा गर्नेछ।",
      pendingMsg: "तपाईंका परिचय कागजातहरू पेश गरिएका छन्। हाम्रो टिमले १–२ कार्यदिनभित्र समीक्षा गर्नेछ। प्रमाणित भएपछि तपाईंले प्लेटफर्मका सबै सुविधा प्रयोग गर्न सक्नुहुन्छ।",
      approvedTitle: "पहिचान प्रमाणित",
      approvedMsg: "तपाईंको KYC प्रमाणीकरण सम्पन्न भयो। तपाईंले घरभाडाका सबै सुविधामा पूर्ण पहुँच पाउनुभएको छ।",
      rejectedTitle: "KYC अस्वीकृत",
      resubmitTitle: "पुनः पेश आवश्यक",
      rejectedFallback: "तपाईंको पेश गरिएको विवरण आवश्यक मापदण्ड पूरा गर्न सकेन।",
      resubmitHelp: "कृपया समस्या सच्याएर तलबाट पुनः पेश गर्नुहोस्।",
      submitFailed: "पेश गर्न असफल भयो। कृपया पुनः प्रयास गर्नुहोस्।",
      networkError: "नेटवर्क त्रुटि। कृपया जडान जाँचेर पुनः प्रयास गर्नुहोस्।",
      goToDashboard: "ड्यासबोर्डमा जानुहोस्",
      modal: {
        ownerBadge: "सम्पत्ति मालिक",
        renterBadge: "भाडावाल",
        ownerHeadline: "आफ्नो मालिक क्षमताको पूर्ण उपयोग गर्नुहोस्",
        renterHeadline: "अरू सबै आवेदकभन्दा अगाडि बढ्नुहोस्",
        ownerSubtext: "प्रमाणित मालिकले बढी विश्वास पाउँछन्, ३x बढी सोधपुछ पाउँछन्, र डिजिटल भाडा भुक्तानी लिन सक्छन् — एउटै छिटो प्रमाणीकरणबाट।",
        renterSubtext: "प्रमाणित भाडावालको आवेदन छिटो स्वीकृत हुन्छ र मालिकको पहिलो प्राथमिकतामा पर्छ। अहिले ५ मिनेट खर्च गर्नुहोस् — मालिकले ‘हो’ भन्ने आवेदक बन्नुहोस्।",
        actionRequiredTitle: "कार्य आवश्यक: आफ्नो KYC पुनः पेश गर्नुहोस्",
        actionRequiredOwnerSubtext: "तपाईंको अघिल्लो पेशी स्वीकृत भएन। कागजात सुधारेर पुनः पेश गरी मालिकका सबै सुविधा पुनः सक्रिय गर्नुहोस्।",
        actionRequiredRenterSubtext: "तपाईंको अघिल्लो पेशी स्वीकृत भएन। स्पष्ट र मान्य कागजातसहित पुनः पेश गरेर पुनः आवेदन दिनुहोस्।",
        pendingStripTitle: "KYC समीक्षाधीन",
        pendingStripMsg: "तपाईंका पहिचान कागजातहरू समीक्षा भइरहेका छन्। प्रमाणित भएपछि (सामान्यतया १–२ कार्यदिन) हामी सूचना दिन्छौं। स्वीकृति भएलगत्तै पूर्ण पहुँच खुल्छ।",
        rejectStripResubmitTitle: "KYC पुनः पेश आवश्यक",
        rejectStripRejectedTitle: "KYC अस्वीकृत",
        rejectStripMsg: "घरभाडा पूर्ण रूपमा प्रयोग गर्न तपाईंले कागजात सुधारेर पुनः पेश गर्नैपर्छ।",
        resubmitNow: "अहिले पुनः पेश गर्नुहोस्",
        verifyNow: "अहिले नै मेरो पहिचान प्रमाणित गर्नुहोस्",
        fixAndResubmit: "सच्याएर कागजात पुनः पेश गर्नुहोस्",
        laterOwner: "म पछि प्रमाणित गर्छु (सिफारिस छैन — सोधपुछ छुट्दैछ)",
        laterRenter: "पछि सम्झाउनुहोस् (ढिलो स्वीकृति भए पनि ठीक छ)",
        ownerBenefits: [
          "हरेक सूचीमा प्रमाणित ब्याज — भाडावालले तुरुन्तै देख्छन् र प्राथमिकता दिन्छन्",
          "खोज नतिजामा माथिल्लो स्थान — प्रमाणित सूचीहरू अघि देखिन्छन्",
          "३x बढी भाडा सोधपुछ — भाडावालले प्रमाणित मालिकलाई बढी विश्वास गर्छन्",
          "घरभाडाबाट डिजिटल भाडा भुक्तानी लिन सकिने — KYC आवश्यक",
          "विवादमा कानुनी सुरक्षा — तपाईंको पहिचान आधिकारिक अभिलेखमा हुन्छ",
          "एकपटकको प्रक्रिया — स्थायी प्रमाणीकरण, वार्षिक नवीकरण आवश्यक छैन"
        ],
        renterBenefits: [
          "तपाईंको प्रोफाइलमा KYC ब्याज — धेरै आवेदनमध्ये छुट्टै देखिनुहोस्",
          "२x छिटो स्वीकृति — मालिकले प्रमाणित भाडावाललाई पहिले छनोट गर्छन्",
          "उच्च स्तरीय सूचीमा आवेदन — केही सूचीमा KYC भाडावाल आवश्यक हुन्छ",
          "सन्देश पठाउनुअघि नै विश्वास — मालिकले छिटो प्रतिक्रिया दिन्छन्",
          "विवादमा पहिचान सुरक्षित — KYC दुबै पक्षका लागि उपयोगी",
          "एकपटकको प्रक्रिया — घरभाडामा स्थायी रूपमा प्रमाणित"
        ],
        ownerProof1: "बढी सोधपुछ",
        ownerProof2: "मालिक सन्तुष्टि",
        ownerProof3: "समीक्षा दिन",
        renterProof1: "छिटो स्वीकृति",
        renterProof2: "मालिक प्राथमिकता",
        renterProof3: "पूरा गर्न समय"
      }
    },
    amenities: {
      sectionTitle: "सुविधाहरू",
      sectionDesc: "तपाईंको सम्पत्तिमा के-के छ?",
      wifi: "वाइफाई",
      kitchen: "भान्साकोठा",
      water: "पानी",
      freeparking: "निःशुल्क पार्किङ",
      airconditioning: "एयर कन्डिसनिङ",
      heating: "तापन",
      electricity: "विद्युत",
      petfriendly: "पाल्तु जनावर मैत्री",
      gym: "जिम",
      hotwater: "तातो पानी",
      playground: "खेलमैदान",
      disablefriendly: "अपाङ्गमैत्री",
    },
    profile: {
      serverError: "सर्भरमा पहुँच गर्न सकिएन। कृपया ब्याकइन्ड पोर्ट ७००० मा चलेको सुनिश्चित गर्नुहोस्।",
      retry: "पुनः प्रयास गर्नुहोस्",
      tabPersonal: "व्यक्तिगत जानकारी",
      tabAccount: "खाता सेटिङ",
      tabKyc: "पहिचान (KYC)",
      roleOwner: "सम्पत्ति मालिक",
      roleRenter: "भाडावाल",
      kycNotSubmitted: "पेश गरिएको छैन",
      kycPending: "समीक्षाधीन",
      kycApproved: "प्रमाणित",
      kycRejected: "अस्वीकृत",
      kycResubmit: "पुनः पेश आवश्यक",
      personalTitle: "व्यक्तिगत जानकारी",
      firstName: "पहिलो नाम",
      firstNamePlaceholder: "पहिलो नाम लेख्नुहोस्",
      lastName: "थर",
      lastNamePlaceholder: "थर लेख्नुहोस्",
      email: "इमेल ठेगाना",
      gender: "लिङ्ग",
      genderSelect: "— छान्नुहोस् —",
      genderMale: "पुरुष",
      genderFemale: "महिला",
      genderOther: "अन्य",
      genderPreferNot: "नबताउन रुचाउँछु",
      countryCode: "देश कोड",
      countryCodePlaceholder: "९७७",
      phone: "फोन नम्बर",
      phonePlaceholder: "९८XXXXXXXX",
      calendarPreference: "पात्रो प्राथमिकता",
      calendarBS: "विक्रम सम्बत (वि.सं.) — नेपाली पात्रो",
      calendarAD: "ईसवी सन् (ई.सं.) — ग्रेगोरियन पात्रो",
      calendarHint: "भाडा भुक्तानी म्याद, सम्झाउने सूचना र मिति प्रदर्शनका लागि प्रयोग गरिन्छ।",
      saveChanges: "परिवर्तन सुरक्षित गर्नुहोस्",
      saving: "सुरक्षित गर्दै…",
      saveSuccess: "प्रोफाइल सफलतापूर्वक अपडेट गरियो।",
      saveErrorRequired: "पहिलो नाम र थर आवश्यक छ।",
      saveErrorFailed: "प्रोफाइल अपडेट गर्न असफल भयो।",
      networkError: "नेटवर्क त्रुटि। कृपया पुनः प्रयास गर्नुहोस्।",
      changePasswordTitle: "पासवर्ड परिवर्तन गर्नुहोस्",
      currentPassword: "हालको पासवर्ड",
      currentPasswordPlaceholder: "हालको पासवर्ड लेख्नुहोस्",
      newPassword: "नयाँ पासवर्ड",
      newPasswordPlaceholder: "कम्तीमा ८ अक्षर",
      confirmPassword: "नयाँ पासवर्ड पुष्टि गर्नुहोस्",
      confirmPasswordPlaceholder: "नयाँ पासवर्ड दोहोर्याउनुहोस्",
      updatePassword: "पासवर्ड अपडेट गर्नुहोस्",
      pwSuccess: "पासवर्ड सफलतापूर्वक परिवर्तन भयो।",
      pwErrorRequired: "सबै फिल्ड आवश्यक छन्।",
      pwErrorMismatch: "नयाँ पासवर्डहरू मेल खाएनन्।",
      pwErrorTooShort: "नयाँ पासवर्ड कम्तीमा ८ अक्षरको हुनुपर्छ।",
      pwErrorFailed: "पासवर्ड परिवर्तन गर्न असफल भयो।",
      accountDetailsTitle: "खाता विवरण",
      accountType: "खाता प्रकार",
      dangerZoneTitle: "खतरनाक क्षेत्र",
      dangerZoneText: "खाता मेटाउनु स्थायी हो। तपाईंका सबै डेटा — सूचीहरू, आवेदनहरू, सन्देशहरू र KYC अभिलेखहरू — हटाइनेछन्। यो कार्य पूर्ववत गर्न सकिँदैन।",
      deleteAccount: "मेरो खाता मेटाउनुहोस्",
      deleteConfirm: "के तपाईं पक्कै निश्चित हुनुहुन्छ? यो पूर्ववत गर्न सकिँदैन।",
      deleteContactSupport: "हो, मेटाउन सहायता टिमलाई सम्पर्क गर्नुहोस्",
      cancel: "रद्द गर्नुहोस्",
      kycTitle: "पहिचान प्रमाणीकरण (KYC)",
      kycStatus: "स्थिति",
      kycVerifiedOn: "प्रमाणित मिति",
      kycAccountRole: "खाता भूमिका",
      kycUnlockedLabel: "तपाईंले पाउनुभएको सुविधाहरू",
      kycGetVerifiedLabel: "प्रमाणित भएपछि के पाउनुहुन्छ",
      kycOwnerBenefits: [
        "हरेक सूचीमा प्रमाणित ब्याज",
        "प्रमाणित नभएका सूचीभन्दा माथिल्लो खोज स्थान",
        "भाडावालबाट ३ गुणा बढी भाडा सोधपुछ",
        "डिजिटल भाडा भुक्तानी प्राप्त गर्ने सुविधा",
        "विवादमा कानुनी पहिचान सुरक्षा"
      ],
      kycRenterBenefits: [
        "भाडावाल प्रोफाइलमा KYC ब्याज",
        "सम्पत्ति मालिकबाट २ गुणा छिटो स्वीकृति",
        "प्रिमियम प्रमाणित सम्पत्ति सूचीमा पहुँच",
        "मालिकले प्रमाणित भाडावाललाई छिटो प्रतिक्रिया दिन्छन्",
        "भाडा विवादमा पहिचान सुरक्षा"
      ],
      kycCtaPending: "पेशी स्थिति हेर्नुहोस्",
      kycCtaResubmit: "सच्याएर कागजात पुनः पेश गर्नुहोस्",
      kycCtaStart: "प्रमाणीकरण सुरु गर्नुहोस् — ५ मिनेट",
    },
    propertySettings: {
      manageDetails: "आफ्नो सम्पत्तिका सबै विवरणहरू व्यवस्थापन गर्नुहोस्",
      basicInfo: "आधारभूत जानकारी",
      basicInfoDesc: "आपनको सम्पत्तिको बारे मा आवश्यक विवरणहरु",
      location: "स्थान",
      locationDesc: "नक्सामा आपनको सम्पत्तिको स्थान चयन गर्नुहोस्",
      pricing: "मूल्य निर्धारण",
      pricingDesc: "भाडा दरहरू र रहेको नीति सेट गर्नुहोस्",
      amenities: "सुविधाहरू",
      amenitiesDesc: "आपनको सम्पत्तिमा उपलब्ध सबै सुविधाहरू चयन गर्नुहोस्",
      images: "तस्बिरहरू",
      imagesDesc: "सम्पत्ति फोटोहरू अपलोड र व्यवस्थापन गर्नुहोस्",
      policies: "नीतिहरू",
      policiesDesc: "घर नियमहरू र अतिथि नीति सेट गर्नुहोस्",
      propertyName: "सम्पत्तिको नाम",
      description: "विवरण",
      propertyType: "सम्पत्तिको प्रकार",
      status: "स्थिति",
      statusActive: "सक्रिय",
      statusInactive: "निष्क्रिय",
      statusMaintenance: "मरम्मत",
      bedrooms: "सोफाका कोठाहरू",
      bathrooms: "बाथरूमहरू",
      area: "क्षेत्र (वर्ग फुट)",
      furnishing: "सज्जा",
      monthlyRent: "मासिक भाडा (NPR)",
      minimumStay: "न्यूनतम रहेको समय (महिना)",
      checkInTime: "चेक-इन समय",
      checkOutTime: "चेक-आउट समय",
      cancellationPolicy: "रद्दीकरण नीति",
      policyStrict: "कठोर (७ दिन अगाडि पूर्ण रिफन्ड)",
      policyModerate: "मध्यम (३ दिन अगाडि ५०% रिफन्ड)",
      policyFlexible: "लचिलो (कहीले पनि पूर्ण रिफन्ड)",
      pickFromMap: "नक्सामा स्थान चयन गर्नुहोस्",
      selectLocation: "स्थान चयन गर्नुहोस्",
      selectedLocation: "चयन गरिएको स्थान",
      mapPreview: "नक्शा पूर्वावलोकन",
      mapPreviewHint: "नक्साबाट स्थान छानेपछि वा मार्कर तानेपछि यो पूर्वावलोकन अद्यावधिक हुन्छ।",
      state: "राज्य/प्रान्त",
      district: "जिल्ला",
      municipality: "नगरपालिका",
      address: "पूर्ण ठेगाना",
      dragOrClick: "यहाँ तस्बिरहरू तान्नुहोस् वा अपलोड गर्न क्लिक गर्नुहोस्",
      supportedFormats: "समर्थन गरे: JPG, PNG, WebP",
      newImages: "अपलोड गर्न नयाँ तस्बिरहरू",
      existingImages: "अवस्थित तस्बिरहरू",
      markedForDelete: "मेटाउनको लागि चिन्हित गरिएको",
      houseRules: "घर नियमहरू",
      petsAllowed: "पोखरी अनुमति दिइएको",
      smokingAllowed: "धुम्रपान अनुमति दिइएको",
      visitorsPolicy: "अतिथि नीति",
      visitorsAllowed: "अतिथिहरू अनुमति दिइएको",
      visitorsRestricted: "अतिथिहरू सीमित गरिएको",
      visitorsNotAllowed: "अतिथिहरू अनुमति नदिइएको",
      verification: "प्रमाणीकरण",
      verificationTitle: "सम्पत्ति प्रमाणीकरण",
      verificationDesc: "प्रमाणित ब्याजद्वारा भाडावालाको भरोसा बढाउनुहोस्",
      verificationStatusApproved: "प्रमाणित",
      verificationStatusPending: "प्रमाणीकरण बाँकी",
      verificationStatusRejected: "प्रमाणीकरण अस्वीकृत",
      verificationStatusUnverified: "प्रमाणित छैन",
      verificationApprovedDesc: "तपाईंको सम्पत्ति प्रमाणीकरण भइसकेको छ। प्रमाणित ब्याज अब तपाईंका सूचीहरूमा देखिन्छ।",
      verificationPendingDesc: "तपाईंको प्रमाणीकरण अनुरोध समीक्षा हुँदैछ। सामान्यतया १-२ कार्यदिवस लाग्छ।",
      verificationRejectedDesc: "तपाईंको प्रमाणीकरण अस्वीकृत भयो। तपाईं कागजात फेरि पेश गर्न सक्नुहुन्छ।",
      verificationUnverifiedDesc: "सम्पत्ति प्रमाणित गराउन प्रमाण कागजातहरू पेश गर्नुहोस्।",
      verificationBenefitsTitle: "प्रमाणीकरणका फाइदाहरू",
      verificationBenefit1: "✓ भाडावालासँग भरोसा निर्माण हुन्छ",
      verificationBenefit2: "✓ सम्पत्तिको दृश्यता बढ्छ",
      verificationBenefit3: "✓ सूचीमा प्रमाणित ब्याज देखिन्छ",
      verificationBenefit4: "✓ ठगीजन्य सोधपुछ कम हुन्छ",
      verificationBenefit5: "✓ भाडामा जाने सम्भावना बढ्छ",
      verificationCtaPending: "प्रमाणीकरण स्थिति जाँच गर्नुहोस्",
      verificationCtaSubmit: "प्रमाणीकरण कागजात पेश गर्नुहोस्",
      verificationSubmitting: "पेश गर्दै...",
      verificationApprovedInfo: "तपाईंको सम्पत्ति प्रमाणित छ र सबै सूचीहरूमा प्रमाणित ब्याज देखिनेछ।",
      verificationOwnershipDoc: "स्वामित्व प्रमाणपत्र",
      verificationTaxDoc: "कर/वडा क्लियरेन्स प्रमाणपत्र",
      verificationLandDoc: "जग्गा धनीपूर्जा (वैकल्पिक)",
      verificationUtilityDoc: "युटिलिटी बिल (वैकल्पिक)",
      verificationNotes: "सहायक टिप्पणी (वैकल्पिक)",
      verificationNotesPlaceholder: "एडमिन समीक्षाका लागि थप विवरण लेख्नुहोस्",
      verificationRequiredDocsError: "कृपया स्वामित्व प्रमाणपत्र र कर/वडा क्लियरेन्स कागजात अपलोड गर्नुहोस्।",
      verificationSubmitted: "प्रमाणीकरण अनुरोध सफलतापूर्वक पेश भयो।",
      verificationStatusUpdated: "प्रमाणीकरण स्थिति अद्यावधिक भयो।",
    },
    propertyDashboard: {
      loading: "सम्पत्ति ड्यासबोर्ड लोड हुँदैछ...",
      loadFailed: "सम्पत्ति ड्यासबोर्ड लोड गर्न सकिएन।",
      failedLoadPropertyData: "सम्पत्ति विवरण लोड गर्न सकिएन।",
      networkErrorTryAgain: "नेटवर्क त्रुटि। कृपया पुनः प्रयास गर्नुहोस्।",
      failedLoadUtilityData: "युटिलिटी डेटा लोड गर्न सकिएन।",
      backOwnerDashboard: "मालिक ड्यासबोर्डमा फर्कनुहोस्",
      ownerDashboard: "मालिक ड्यासबोर्ड",
      propertyDashboardTitle: "सम्पत्ति ड्यासबोर्ड",
      locationNotSet: "स्थान सेट गरिएको छैन",
      rented: "भाडामा",
      vacant: "खाली",
      verified: "प्रमाणित",
      verificationPending: "प्रमाणीकरण बाँकी",
      rejected: "अस्वीकृत",
      notVerified: "प्रमाणित छैन",
      tabOverview: "अवलोकन",
      tabUtilities: "युटिलिटीहरू",
      tabSettings: "सम्पत्ति सेटिङ",
      monthlyRent: "मासिक भाडा",
      utilitiesBilledTracked: "युटिलिटी बिल (ट्र्याक गरिएको)",
      leaseProgress: "लिज प्रगति",
      daysRemaining: "बाँकी दिन",
      pendingApplications: "पेन्डिङ आवेदनहरू",
      leaseTimeline: "लिज समयरेखा",
      to: "देखि",
      noActiveLease: "सक्रिय लिज छैन",
      elapsed: "बितेको",
      total: "कुल",
      daysShort: "दिन",
      activeTenancyAndPaymentContext: "सक्रिय बसोबास र भुक्तानी सन्दर्भ",
      terminationRequested: "समाप्ति अनुरोध गरिएको",
      terminationInProgress: "समाप्ति प्रक्रिया जारी छ",
      requestedBy: "अनुरोधकर्ता",
      you: "तपाईं",
      cancelRequest: "अनुरोध रद्द गर्नुहोस्",
      tenantInformation: "भाडावाल जानकारी",
      fullName: "पूरा नाम",
      email: "इमेल",
      phone: "फोन",
      leaseDetails: "लिज विवरण",
      startDate: "सुरु मिति",
      endDate: "अन्त्य मिति",
      status: "स्थिति",
      unknown: "अज्ञात",
      paymentSummary: "भुक्तानी सारांश",
      utilityTracked: "ट्र्याक गरिएको युटिलिटी",
      calendar: "पात्रो",
      bikramSambat: "विक्रम सम्बत",
      change: "परिवर्तन",
      propertyIsVacant: "सम्पत्ति खाली छ",
      noActiveTenancyDesc: "सक्रिय बसोबास छैन। तपाईं अझै पनि Utilities ट्याबमा युटिलिटी दर र मिटर आधार इकाइ सेट गर्न सक्नुहुन्छ।",
      configureUtilities: "युटिलिटी सेट गर्नुहोस्",
      propertySnapshot: "सम्पत्ति स्न्यापसट",
      bed: "कोठा",
      bath: "बाथ",
      sqft: "वर्ग फिट",
      locationPending: "स्थान बाँकी",
      utilityBillingTitle: "युटिलिटी बिलिङ र मिटर जानकारी",
      utilityBillingDesc: "बिजुली/पानी मिटर युनिट ट्र्याक गर्नुहोस्, दर अद्यावधिक गर्नुहोस्, बिल अनुमान गर्नुहोस् र रिडिङ इतिहास राख्नुहोस्।",
      loadingUtilityData: "युटिलिटी डेटा लोड हुँदैछ...",
      utilityProfileSetup: "युटिलिटी प्रोफाइल सेटअप",
      utilityProfileSetupDesc: "मिटर नम्बर, सुरुआती युनिट र प्रति युनिट दर सेट गर्नुहोस्।",
      electricityMeterNo: "बिजुली मिटर नं",
      waterMeterNo: "पानी मिटर नं",
      electricityMeterNoPlaceholder: "जस्तै, NEA-12234",
      waterMeterNoPlaceholder: "जस्तै, KUKL-7788",
      electricityRatePerUnit: "बिजुली दर प्रति युनिट (NPR)",
      waterRatePerUnit: "पानी दर प्रति युनिट (NPR)",
      electricityRate: "बिजुली दर",
      waterRate: "पानी दर",
      electricityStartUnit: "बिजुली सुरुआती युनिट",
      waterStartUnit: "पानी सुरुआती युनिट",
      meterStartDate: "मिटर सुरु मिति",
      notes: "टिप्पणी",
      optionalBillingRemarks: "वैकल्पिक बिलिङ टिप्पणी",
      saving: "सुरक्षित गर्दै...",
      saveUtilityProfile: "युटिलिटी प्रोफाइल सुरक्षित गर्नुहोस्",
      couldNotSaveUtilityProfile: "युटिलिटी प्रोफाइल सुरक्षित गर्न सकिएन।",
      utilityProfileSaved: "युटिलिटी प्रोफाइल सुरक्षित भयो।",
      networkErrorSavingUtilityProfile: "युटिलिटी प्रोफाइल सुरक्षित गर्दा नेटवर्क त्रुटि भयो।",
      priceEstimator: "मूल्य अनुमानक",
      priceEstimatorDesc: "दर र युनिट खपतबाट तुरुन्त अनुमान।",
      electricityUnitsKwh: "बिजुली युनिट (kWh)",
      waterUnitsOnly: "पानी युनिट",
      totalEstimate: "कुल अनुमान",
      latestRecordedMeters: "पछिल्लो रेकर्ड गरिएको मिटर",
      units: "युनिट",
      on: "मा",
      noReadingYet: "अहिलेसम्म रिडिङ छैन",
      add: "थप्नुहोस्",
      meterReading: "मिटर रिडिङ",
      readingDate: "रिडिङ मिति",
      meterUnit: "मिटर युनिट",
      currentMeterUnit: "हालको मिटर युनिट",
      optionalNote: "वैकल्पिक टिप्पणी",
      couldNotAdd: "थप्न सकिएन",
      reading: "रिडिङ",
      meterReadingAdded: "मिटर रिडिङ थपियो।",
      networkErrorAddingReading: "रिडिङ थप्दा नेटवर्क त्रुटि भयो।",
      utilityReadingHistory: "युटिलिटी रिडिङ इतिहास",
      date: "मिति",
      consumed: "खपत",
      rate: "दर",
      amount: "रकम",
      noReadingsYet: "अहिलेसम्म रिडिङ छैन।",
      thisMonthUtilities: "यस महिनाको युटिलिटी",
      monthlyUtilityRecords: "मासिक युटिलिटी अभिलेख",
      month: "महिना",
      electricityUnits: "बिजुली युनिट",
      electricityAmount: "बिजुली रकम",
      waterUnits: "पानी युनिट",
      waterAmount: "पानी रकम",
      totalAmount: "कुल रकम",
      noMonthlyRecords: "अहिलेसम्म मासिक अभिलेख छैन।",
      confirmTitle: "कृपया पुष्टि गर्नुहोस्",
      confirmCriticalUpdateTitle: "महत्वपूर्ण युटिलिटी अपडेट पुष्टि गर्नुहोस्",
      confirmCriticalUpdateMsg: "तपाईं महत्वपूर्ण युटिलिटी संख्या अपडेट गर्न लाग्नुभएको छ।",
      confirmReadingTitle: "मिटर रिडिङ पुष्टि गर्नुहोस्",
      utility: "युटिलिटी",
      electricity: "बिजुली",
      water: "पानी",
      previousUnit: "अघिल्लो युनिट",
      newUnit: "नयाँ युनिट",
      consumedUnits: "खपत युनिट",
      estimatedAmount: "अनुमानित रकम",
      updateNow: "अहिले अपडेट गर्नुहोस्",
      saveReading: "रिडिङ सुरक्षित गर्नुहोस्",
      proceed: "अगाडि बढ्नुहोस्",
      cancel: "रद्द गर्नुहोस्",
      close: "बन्द गर्नुहोस्",
      readingRequired: "रिडिङ मिति र मिटर युनिट आवश्यक छन्।",
      requestLeaseTermination: "लिज समाप्ति अनुरोध",
      pleaseProvideReason: "कृपया कारण लेख्नुहोस्।",
      failedToSubmitRequest: "अनुरोध पठाउन असफल भयो।",
      terminationRequestSent: "समाप्ति अनुरोध भाडावाललाई पठाइयो।",
      terminationModalMsgPrefix: "यसले समाप्ति अनुरोध पठाउँछ",
      terminationModalMsgSuffix: "स्वीकृति भएपछि मात्र लिज समाप्त हुनेछ।",
      terminationReasonPlaceholder: "लिज समाप्त गर्ने कारण लेख्नुहोस्",
      tenant: "भाडावाल",
      reason: "कारण",
      sendRequest: "अनुरोध पठाउनुहोस्",
      sending: "पठाउँदै...",
    },
    },
};

export default translations;
